/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as OtpRouteImport } from './routes/otp'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedTodayRouteImport } from './routes/_authed.today'
import { Route as AuthedProgressRouteImport } from './routes/_authed.progress'
import { Route as AuthedOperationsRouteImport } from './routes/_authed.operations'
import { Route as AuthedGamesRouteImport } from './routes/_authed.games'
import { Route as AuthedFinanceOpsRouteImport } from './routes/_authed.finance-ops'
import { Route as AuthedFamilyRouteImport } from './routes/_authed.family'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedControlCenterRouteImport } from './routes/_authed.control-center'
import { Route as AuthedChangePasswordRouteImport } from './routes/_authed.change-password'
import { Route as AuthedAnnouncementsRouteImport } from './routes/_authed.announcements'
import { Route as AuthedAcademicOpsRouteImport } from './routes/_authed.academic-ops'
import { Route as AuthedSystemUsersRouteImport } from './routes/_authed.system.users'
import { Route as AuthedSystemTeacherReportsRouteImport } from './routes/_authed.system.teacher-reports'
import { Route as AuthedSystemSettingsRouteImport } from './routes/_authed.system.settings'
import { Route as AuthedSystemScheduledJobsRouteImport } from './routes/_authed.system.scheduled-jobs'
import { Route as AuthedSystemPerformanceConfigRouteImport } from './routes/_authed.system.performance-config'
import { Route as AuthedSystemHiringConfigRouteImport } from './routes/_authed.system.hiring-config'
import { Route as AuthedSystemFeatureFlagsRouteImport } from './routes/_authed.system.feature-flags'
import { Route as AuthedSystemCalendarRouteImport } from './routes/_authed.system.calendar'
import { Route as AuthedSystemAuditRouteImport } from './routes/_authed.system.audit'
import { Route as AuthedPeopleTeachersRouteImport } from './routes/_authed.people.teachers'
import { Route as AuthedPeopleStudentsRouteImport } from './routes/_authed.people.students'
import { Route as AuthedPeopleManagersRouteImport } from './routes/_authed.people.managers'
import { Route as AuthedPeopleHouseholdsRouteImport } from './routes/_authed.people.households'
import { Route as AuthedMeReportsRouteImport } from './routes/_authed.me.reports'
import { Route as AuthedMeReferralsRouteImport } from './routes/_authed.me.referrals'
import { Route as AuthedMePointsRouteImport } from './routes/_authed.me.points'
import { Route as AuthedMePerformanceRouteImport } from './routes/_authed.me.performance'
import { Route as AuthedMeMarksRouteImport } from './routes/_authed.me.marks'
import { Route as AuthedMeLeaveRouteImport } from './routes/_authed.me.leave'
import { Route as AuthedMeFeesRouteImport } from './routes/_authed.me.fees'
import { Route as AuthedMeFeedbackRouteImport } from './routes/_authed.me.feedback'
import { Route as AuthedMeChildrenRouteImport } from './routes/_authed.me.children'
import { Route as AuthedMeAttendanceRouteImport } from './routes/_authed.me.attendance'
import { Route as AuthedMeAssessmentsRouteImport } from './routes/_authed.me.assessments'
import { Route as AuthedHrProbationRouteImport } from './routes/_authed.hr.probation'
import { Route as AuthedHrPerformanceRouteImport } from './routes/_authed.hr.performance'
import { Route as AuthedHrInterviewsRouteImport } from './routes/_authed.hr.interviews'
import { Route as AuthedHrFeedbackRouteImport } from './routes/_authed.hr.feedback'
import { Route as AuthedHrApplicationsRouteImport } from './routes/_authed.hr.applications'
import { Route as AuthedGamesRunIdRouteImport } from './routes/_authed.games.$runId'
import { Route as AuthedFinanceWithdrawalsRouteImport } from './routes/_authed.finance.withdrawals'
import { Route as AuthedFinanceSalariesRouteImport } from './routes/_authed.finance.salaries'
import { Route as AuthedFinanceReceiptsRouteImport } from './routes/_authed.finance.receipts'
import { Route as AuthedFinanceIncentivesRouteImport } from './routes/_authed.finance.incentives'
import { Route as AuthedFinanceFeesRouteImport } from './routes/_authed.finance.fees'
import { Route as AuthedCandidateStatusRouteImport } from './routes/_authed.candidate.status'
import { Route as AuthedCandidateRulesRouteImport } from './routes/_authed.candidate.rules'
import { Route as AuthedCandidateOnboardRouteImport } from './routes/_authed.candidate.onboard'
import { Route as AuthedCandidateDemosRouteImport } from './routes/_authed.candidate.demos'
import { Route as AuthedCandidateAptitudeRouteImport } from './routes/_authed.candidate.aptitude'
import { Route as AuthedAnnouncementsAnnouncementIdRouteImport } from './routes/_authed.announcements.$announcementId'
import { Route as AuthedAcademicsWeeklySheetRouteImport } from './routes/_authed.academics.weekly-sheet'
import { Route as AuthedAcademicsResourcesRouteImport } from './routes/_authed.academics.resources'
import { Route as AuthedAcademicsReportReviewRouteImport } from './routes/_authed.academics.report-review'
import { Route as AuthedAcademicsReportLeaderboardRouteImport } from './routes/_authed.academics.report-leaderboard'
import { Route as AuthedAcademicsProgressRouteImport } from './routes/_authed.academics.progress'
import { Route as AuthedAcademicsMeetingsRouteImport } from './routes/_authed.academics.meetings'
import { Route as AuthedAcademicsLeaveRouteImport } from './routes/_authed.academics.leave'
import { Route as AuthedAcademicsExamsRouteImport } from './routes/_authed.academics.exams'
import { Route as AuthedAcademicsCoursesRouteImport } from './routes/_authed.academics.courses'
import { Route as AuthedAcademicsBatchesRouteImport } from './routes/_authed.academics.batches'
import { Route as AuthedAcademicsAttendanceRouteImport } from './routes/_authed.academics.attendance'
import { Route as AuthedAcademicsAssessmentsRouteImport } from './routes/_authed.academics.assessments'
import { Route as AuthedSystemWalletAdjustmentsRouteImport } from './routes/_authed.system.wallet.adjustments'
import { Route as AuthedSystemUsersUserIdRouteImport } from './routes/_authed.system.users.$userId'
import { Route as AuthedSystemTeacherReportTemplatesTemplateIdRouteImport } from './routes/_authed.system.teacher-report-templates.$templateId'
import { Route as AuthedPeopleTeachersTeacherIdRouteImport } from './routes/_authed.people.teachers.$teacherId'
import { Route as AuthedPeopleStudentsStudentIdRouteImport } from './routes/_authed.people.students.$studentId'
import { Route as AuthedPeopleManagersManagerIdRouteImport } from './routes/_authed.people.managers.$managerId'
import { Route as AuthedPeopleHouseholdsHouseholdIdRouteImport } from './routes/_authed.people.households.$householdId'
import { Route as AuthedHrProbationTeacherIdRouteImport } from './routes/_authed.hr.probation.$teacherId'
import { Route as AuthedHrInterviewsSlotIdRouteImport } from './routes/_authed.hr.interviews.$slotId'
import { Route as AuthedHrApplicationsApplicationIdRouteImport } from './routes/_authed.hr.applications.$applicationId'
import { Route as AuthedFinanceWithdrawalsWithdrawalIdRouteImport } from './routes/_authed.finance.withdrawals.$withdrawalId'
import { Route as AuthedFinanceSalariesCycleIdRouteImport } from './routes/_authed.finance.salaries.$cycleId'
import { Route as AuthedFinanceReceiptsPaymentIdRouteImport } from './routes/_authed.finance.receipts.$paymentId'
import { Route as AuthedFinancePayslipsPaymentIdRouteImport } from './routes/_authed.finance.payslips.$paymentId'
import { Route as AuthedFinanceFeesClaimsRouteImport } from './routes/_authed.finance.fees.claims'
import { Route as AuthedFinanceFeesCycleIdRouteImport } from './routes/_authed.finance.fees.$cycleId'
import { Route as AuthedCandidateInterviewBookRouteImport } from './routes/_authed.candidate.interview.book'
import { Route as AuthedAssessmentsAttemptsAttemptIdRouteImport } from './routes/_authed.assessments.attempts.$attemptId'
import { Route as AuthedAcademicsResourcesResourceIdRouteImport } from './routes/_authed.academics.resources.$resourceId'
import { Route as AuthedAcademicsMeetingsMeetingIdRouteImport } from './routes/_authed.academics.meetings.$meetingId'
import { Route as AuthedAcademicsExamsCycleIdRouteImport } from './routes/_authed.academics.exams.$cycleId'
import { Route as AuthedAcademicsCoursesCourseIdRouteImport } from './routes/_authed.academics.courses.$courseId'
import { Route as AuthedAcademicsBatchesBatchIdRouteImport } from './routes/_authed.academics.batches.$batchId'
import { Route as AuthedAcademicsAssessmentsTemplateIdRouteImport } from './routes/_authed.academics.assessments.$templateId'
import { Route as AuthedMeChildrenStudentIdMarksRouteImport } from './routes/_authed.me.children.$studentId.marks'
import { Route as AuthedHrPerformanceTeachersTeacherIdRouteImport } from './routes/_authed.hr.performance.teachers.$teacherId'
import { Route as AuthedHrFeedbackTeachersTeacherIdRouteImport } from './routes/_authed.hr.feedback.teachers.$teacherId'
import { Route as AuthedHrFeedbackSubmissionsSubmissionIdRouteImport } from './routes/_authed.hr.feedback.submissions.$submissionId'
import { Route as AuthedHrFeedbackFormsFormIdRouteImport } from './routes/_authed.hr.feedback.forms.$formId'
import { Route as AuthedFinanceSalariesPaymentsPaymentIdRouteImport } from './routes/_authed.finance.salaries.payments.$paymentId'
import { Route as AuthedFinanceFeesPaymentsPaymentIdRouteImport } from './routes/_authed.finance.fees.payments.$paymentId'
import { Route as AuthedFinanceFeesClaimsClaimIdRouteImport } from './routes/_authed.finance.fees.claims.$claimId'
import { Route as AuthedAssessmentsRunsRunIdStartRouteImport } from './routes/_authed.assessments.runs.$runId.start'
import { Route as AuthedAssessmentsAttemptsAttemptIdResultRouteImport } from './routes/_authed.assessments.attempts.$attemptId.result'
import { Route as AuthedAcademicsAssessmentsRunsRunIdRouteImport } from './routes/_authed.academics.assessments.runs.$runId'
import { Route as AuthedMeReportKindBatchIdPeriodKeyRouteImport } from './routes/_authed.me.report.$kind.$batchId.$periodKey'

const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpRoute = OtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTodayRoute = AuthedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProgressRoute = AuthedProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOperationsRoute = AuthedOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGamesRoute = AuthedGamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFinanceOpsRoute = AuthedFinanceOpsRouteImport.update({
  id: '/finance-ops',
  path: '/finance-ops',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFamilyRoute = AuthedFamilyRouteImport.update({
  id: '/family',
  path: '/family',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedControlCenterRoute = AuthedControlCenterRouteImport.update({
  id: '/control-center',
  path: '/control-center',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChangePasswordRoute = AuthedChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnnouncementsRoute = AuthedAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicOpsRoute = AuthedAcademicOpsRouteImport.update({
  id: '/academic-ops',
  path: '/academic-ops',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSystemUsersRoute = AuthedSystemUsersRouteImport.update({
  id: '/system/users',
  path: '/system/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSystemTeacherReportsRoute =
  AuthedSystemTeacherReportsRouteImport.update({
    id: '/system/teacher-reports',
    path: '/system/teacher-reports',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemSettingsRoute = AuthedSystemSettingsRouteImport.update({
  id: '/system/settings',
  path: '/system/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSystemScheduledJobsRoute =
  AuthedSystemScheduledJobsRouteImport.update({
    id: '/system/scheduled-jobs',
    path: '/system/scheduled-jobs',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemPerformanceConfigRoute =
  AuthedSystemPerformanceConfigRouteImport.update({
    id: '/system/performance-config',
    path: '/system/performance-config',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemHiringConfigRoute =
  AuthedSystemHiringConfigRouteImport.update({
    id: '/system/hiring-config',
    path: '/system/hiring-config',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemFeatureFlagsRoute =
  AuthedSystemFeatureFlagsRouteImport.update({
    id: '/system/feature-flags',
    path: '/system/feature-flags',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemCalendarRoute = AuthedSystemCalendarRouteImport.update({
  id: '/system/calendar',
  path: '/system/calendar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSystemAuditRoute = AuthedSystemAuditRouteImport.update({
  id: '/system/audit',
  path: '/system/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleTeachersRoute = AuthedPeopleTeachersRouteImport.update({
  id: '/people/teachers',
  path: '/people/teachers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleStudentsRoute = AuthedPeopleStudentsRouteImport.update({
  id: '/people/students',
  path: '/people/students',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleManagersRoute = AuthedPeopleManagersRouteImport.update({
  id: '/people/managers',
  path: '/people/managers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleHouseholdsRoute = AuthedPeopleHouseholdsRouteImport.update({
  id: '/people/households',
  path: '/people/households',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeReportsRoute = AuthedMeReportsRouteImport.update({
  id: '/me/reports',
  path: '/me/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeReferralsRoute = AuthedMeReferralsRouteImport.update({
  id: '/me/referrals',
  path: '/me/referrals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMePointsRoute = AuthedMePointsRouteImport.update({
  id: '/me/points',
  path: '/me/points',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMePerformanceRoute = AuthedMePerformanceRouteImport.update({
  id: '/me/performance',
  path: '/me/performance',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeMarksRoute = AuthedMeMarksRouteImport.update({
  id: '/me/marks',
  path: '/me/marks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeLeaveRoute = AuthedMeLeaveRouteImport.update({
  id: '/me/leave',
  path: '/me/leave',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeFeesRoute = AuthedMeFeesRouteImport.update({
  id: '/me/fees',
  path: '/me/fees',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeFeedbackRoute = AuthedMeFeedbackRouteImport.update({
  id: '/me/feedback',
  path: '/me/feedback',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeChildrenRoute = AuthedMeChildrenRouteImport.update({
  id: '/me/children',
  path: '/me/children',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeAttendanceRoute = AuthedMeAttendanceRouteImport.update({
  id: '/me/attendance',
  path: '/me/attendance',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeAssessmentsRoute = AuthedMeAssessmentsRouteImport.update({
  id: '/me/assessments',
  path: '/me/assessments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHrProbationRoute = AuthedHrProbationRouteImport.update({
  id: '/hr/probation',
  path: '/hr/probation',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHrPerformanceRoute = AuthedHrPerformanceRouteImport.update({
  id: '/hr/performance',
  path: '/hr/performance',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHrInterviewsRoute = AuthedHrInterviewsRouteImport.update({
  id: '/hr/interviews',
  path: '/hr/interviews',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHrFeedbackRoute = AuthedHrFeedbackRouteImport.update({
  id: '/hr/feedback',
  path: '/hr/feedback',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHrApplicationsRoute = AuthedHrApplicationsRouteImport.update({
  id: '/hr/applications',
  path: '/hr/applications',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGamesRunIdRoute = AuthedGamesRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AuthedGamesRoute,
} as any)
const AuthedFinanceWithdrawalsRoute =
  AuthedFinanceWithdrawalsRouteImport.update({
    id: '/finance/withdrawals',
    path: '/finance/withdrawals',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedFinanceSalariesRoute = AuthedFinanceSalariesRouteImport.update({
  id: '/finance/salaries',
  path: '/finance/salaries',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFinanceReceiptsRoute = AuthedFinanceReceiptsRouteImport.update({
  id: '/finance/receipts',
  path: '/finance/receipts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFinanceIncentivesRoute = AuthedFinanceIncentivesRouteImport.update({
  id: '/finance/incentives',
  path: '/finance/incentives',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFinanceFeesRoute = AuthedFinanceFeesRouteImport.update({
  id: '/finance/fees',
  path: '/finance/fees',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCandidateStatusRoute = AuthedCandidateStatusRouteImport.update({
  id: '/candidate/status',
  path: '/candidate/status',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCandidateRulesRoute = AuthedCandidateRulesRouteImport.update({
  id: '/candidate/rules',
  path: '/candidate/rules',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCandidateOnboardRoute = AuthedCandidateOnboardRouteImport.update({
  id: '/candidate/onboard',
  path: '/candidate/onboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCandidateDemosRoute = AuthedCandidateDemosRouteImport.update({
  id: '/candidate/demos',
  path: '/candidate/demos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCandidateAptitudeRoute = AuthedCandidateAptitudeRouteImport.update({
  id: '/candidate/aptitude',
  path: '/candidate/aptitude',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnnouncementsAnnouncementIdRoute =
  AuthedAnnouncementsAnnouncementIdRouteImport.update({
    id: '/$announcementId',
    path: '/$announcementId',
    getParentRoute: () => AuthedAnnouncementsRoute,
  } as any)
const AuthedAcademicsWeeklySheetRoute =
  AuthedAcademicsWeeklySheetRouteImport.update({
    id: '/academics/weekly-sheet',
    path: '/academics/weekly-sheet',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAcademicsResourcesRoute =
  AuthedAcademicsResourcesRouteImport.update({
    id: '/academics/resources',
    path: '/academics/resources',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAcademicsReportReviewRoute =
  AuthedAcademicsReportReviewRouteImport.update({
    id: '/academics/report-review',
    path: '/academics/report-review',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAcademicsReportLeaderboardRoute =
  AuthedAcademicsReportLeaderboardRouteImport.update({
    id: '/academics/report-leaderboard',
    path: '/academics/report-leaderboard',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAcademicsProgressRoute = AuthedAcademicsProgressRouteImport.update({
  id: '/academics/progress',
  path: '/academics/progress',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicsMeetingsRoute = AuthedAcademicsMeetingsRouteImport.update({
  id: '/academics/meetings',
  path: '/academics/meetings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicsLeaveRoute = AuthedAcademicsLeaveRouteImport.update({
  id: '/academics/leave',
  path: '/academics/leave',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicsExamsRoute = AuthedAcademicsExamsRouteImport.update({
  id: '/academics/exams',
  path: '/academics/exams',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicsCoursesRoute = AuthedAcademicsCoursesRouteImport.update({
  id: '/academics/courses',
  path: '/academics/courses',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicsBatchesRoute = AuthedAcademicsBatchesRouteImport.update({
  id: '/academics/batches',
  path: '/academics/batches',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcademicsAttendanceRoute =
  AuthedAcademicsAttendanceRouteImport.update({
    id: '/academics/attendance',
    path: '/academics/attendance',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAcademicsAssessmentsRoute =
  AuthedAcademicsAssessmentsRouteImport.update({
    id: '/academics/assessments',
    path: '/academics/assessments',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemWalletAdjustmentsRoute =
  AuthedSystemWalletAdjustmentsRouteImport.update({
    id: '/system/wallet/adjustments',
    path: '/system/wallet/adjustments',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSystemUsersUserIdRoute = AuthedSystemUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthedSystemUsersRoute,
} as any)
const AuthedSystemTeacherReportTemplatesTemplateIdRoute =
  AuthedSystemTeacherReportTemplatesTemplateIdRouteImport.update({
    id: '/system/teacher-report-templates/$templateId',
    path: '/system/teacher-report-templates/$templateId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPeopleTeachersTeacherIdRoute =
  AuthedPeopleTeachersTeacherIdRouteImport.update({
    id: '/$teacherId',
    path: '/$teacherId',
    getParentRoute: () => AuthedPeopleTeachersRoute,
  } as any)
const AuthedPeopleStudentsStudentIdRoute =
  AuthedPeopleStudentsStudentIdRouteImport.update({
    id: '/$studentId',
    path: '/$studentId',
    getParentRoute: () => AuthedPeopleStudentsRoute,
  } as any)
const AuthedPeopleManagersManagerIdRoute =
  AuthedPeopleManagersManagerIdRouteImport.update({
    id: '/$managerId',
    path: '/$managerId',
    getParentRoute: () => AuthedPeopleManagersRoute,
  } as any)
const AuthedPeopleHouseholdsHouseholdIdRoute =
  AuthedPeopleHouseholdsHouseholdIdRouteImport.update({
    id: '/$householdId',
    path: '/$householdId',
    getParentRoute: () => AuthedPeopleHouseholdsRoute,
  } as any)
const AuthedHrProbationTeacherIdRoute =
  AuthedHrProbationTeacherIdRouteImport.update({
    id: '/$teacherId',
    path: '/$teacherId',
    getParentRoute: () => AuthedHrProbationRoute,
  } as any)
const AuthedHrInterviewsSlotIdRoute =
  AuthedHrInterviewsSlotIdRouteImport.update({
    id: '/$slotId',
    path: '/$slotId',
    getParentRoute: () => AuthedHrInterviewsRoute,
  } as any)
const AuthedHrApplicationsApplicationIdRoute =
  AuthedHrApplicationsApplicationIdRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => AuthedHrApplicationsRoute,
  } as any)
const AuthedFinanceWithdrawalsWithdrawalIdRoute =
  AuthedFinanceWithdrawalsWithdrawalIdRouteImport.update({
    id: '/$withdrawalId',
    path: '/$withdrawalId',
    getParentRoute: () => AuthedFinanceWithdrawalsRoute,
  } as any)
const AuthedFinanceSalariesCycleIdRoute =
  AuthedFinanceSalariesCycleIdRouteImport.update({
    id: '/$cycleId',
    path: '/$cycleId',
    getParentRoute: () => AuthedFinanceSalariesRoute,
  } as any)
const AuthedFinanceReceiptsPaymentIdRoute =
  AuthedFinanceReceiptsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => AuthedFinanceReceiptsRoute,
  } as any)
const AuthedFinancePayslipsPaymentIdRoute =
  AuthedFinancePayslipsPaymentIdRouteImport.update({
    id: '/finance/payslips/$paymentId',
    path: '/finance/payslips/$paymentId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedFinanceFeesClaimsRoute = AuthedFinanceFeesClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AuthedFinanceFeesRoute,
} as any)
const AuthedFinanceFeesCycleIdRoute =
  AuthedFinanceFeesCycleIdRouteImport.update({
    id: '/$cycleId',
    path: '/$cycleId',
    getParentRoute: () => AuthedFinanceFeesRoute,
  } as any)
const AuthedCandidateInterviewBookRoute =
  AuthedCandidateInterviewBookRouteImport.update({
    id: '/candidate/interview/book',
    path: '/candidate/interview/book',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAssessmentsAttemptsAttemptIdRoute =
  AuthedAssessmentsAttemptsAttemptIdRouteImport.update({
    id: '/assessments/attempts/$attemptId',
    path: '/assessments/attempts/$attemptId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAcademicsResourcesResourceIdRoute =
  AuthedAcademicsResourcesResourceIdRouteImport.update({
    id: '/$resourceId',
    path: '/$resourceId',
    getParentRoute: () => AuthedAcademicsResourcesRoute,
  } as any)
const AuthedAcademicsMeetingsMeetingIdRoute =
  AuthedAcademicsMeetingsMeetingIdRouteImport.update({
    id: '/$meetingId',
    path: '/$meetingId',
    getParentRoute: () => AuthedAcademicsMeetingsRoute,
  } as any)
const AuthedAcademicsExamsCycleIdRoute =
  AuthedAcademicsExamsCycleIdRouteImport.update({
    id: '/$cycleId',
    path: '/$cycleId',
    getParentRoute: () => AuthedAcademicsExamsRoute,
  } as any)
const AuthedAcademicsCoursesCourseIdRoute =
  AuthedAcademicsCoursesCourseIdRouteImport.update({
    id: '/$courseId',
    path: '/$courseId',
    getParentRoute: () => AuthedAcademicsCoursesRoute,
  } as any)
const AuthedAcademicsBatchesBatchIdRoute =
  AuthedAcademicsBatchesBatchIdRouteImport.update({
    id: '/$batchId',
    path: '/$batchId',
    getParentRoute: () => AuthedAcademicsBatchesRoute,
  } as any)
const AuthedAcademicsAssessmentsTemplateIdRoute =
  AuthedAcademicsAssessmentsTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthedAcademicsAssessmentsRoute,
  } as any)
const AuthedMeChildrenStudentIdMarksRoute =
  AuthedMeChildrenStudentIdMarksRouteImport.update({
    id: '/$studentId/marks',
    path: '/$studentId/marks',
    getParentRoute: () => AuthedMeChildrenRoute,
  } as any)
const AuthedHrPerformanceTeachersTeacherIdRoute =
  AuthedHrPerformanceTeachersTeacherIdRouteImport.update({
    id: '/teachers/$teacherId',
    path: '/teachers/$teacherId',
    getParentRoute: () => AuthedHrPerformanceRoute,
  } as any)
const AuthedHrFeedbackTeachersTeacherIdRoute =
  AuthedHrFeedbackTeachersTeacherIdRouteImport.update({
    id: '/teachers/$teacherId',
    path: '/teachers/$teacherId',
    getParentRoute: () => AuthedHrFeedbackRoute,
  } as any)
const AuthedHrFeedbackSubmissionsSubmissionIdRoute =
  AuthedHrFeedbackSubmissionsSubmissionIdRouteImport.update({
    id: '/submissions/$submissionId',
    path: '/submissions/$submissionId',
    getParentRoute: () => AuthedHrFeedbackRoute,
  } as any)
const AuthedHrFeedbackFormsFormIdRoute =
  AuthedHrFeedbackFormsFormIdRouteImport.update({
    id: '/forms/$formId',
    path: '/forms/$formId',
    getParentRoute: () => AuthedHrFeedbackRoute,
  } as any)
const AuthedFinanceSalariesPaymentsPaymentIdRoute =
  AuthedFinanceSalariesPaymentsPaymentIdRouteImport.update({
    id: '/payments/$paymentId',
    path: '/payments/$paymentId',
    getParentRoute: () => AuthedFinanceSalariesRoute,
  } as any)
const AuthedFinanceFeesPaymentsPaymentIdRoute =
  AuthedFinanceFeesPaymentsPaymentIdRouteImport.update({
    id: '/payments/$paymentId',
    path: '/payments/$paymentId',
    getParentRoute: () => AuthedFinanceFeesRoute,
  } as any)
const AuthedFinanceFeesClaimsClaimIdRoute =
  AuthedFinanceFeesClaimsClaimIdRouteImport.update({
    id: '/$claimId',
    path: '/$claimId',
    getParentRoute: () => AuthedFinanceFeesClaimsRoute,
  } as any)
const AuthedAssessmentsRunsRunIdStartRoute =
  AuthedAssessmentsRunsRunIdStartRouteImport.update({
    id: '/assessments/runs/$runId/start',
    path: '/assessments/runs/$runId/start',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAssessmentsAttemptsAttemptIdResultRoute =
  AuthedAssessmentsAttemptsAttemptIdResultRouteImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => AuthedAssessmentsAttemptsAttemptIdRoute,
  } as any)
const AuthedAcademicsAssessmentsRunsRunIdRoute =
  AuthedAcademicsAssessmentsRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthedAcademicsAssessmentsRoute,
  } as any)
const AuthedMeReportKindBatchIdPeriodKeyRoute =
  AuthedMeReportKindBatchIdPeriodKeyRouteImport.update({
    id: '/me/report/$kind/$batchId/$periodKey',
    path: '/me/report/$kind/$batchId/$periodKey',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/reset': typeof ResetRoute
  '/academic-ops': typeof AuthedAcademicOpsRoute
  '/announcements': typeof AuthedAnnouncementsRouteWithChildren
  '/change-password': typeof AuthedChangePasswordRoute
  '/control-center': typeof AuthedControlCenterRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/family': typeof AuthedFamilyRoute
  '/finance-ops': typeof AuthedFinanceOpsRoute
  '/games': typeof AuthedGamesRouteWithChildren
  '/operations': typeof AuthedOperationsRoute
  '/progress': typeof AuthedProgressRoute
  '/today': typeof AuthedTodayRoute
  '/academics/assessments': typeof AuthedAcademicsAssessmentsRouteWithChildren
  '/academics/attendance': typeof AuthedAcademicsAttendanceRoute
  '/academics/batches': typeof AuthedAcademicsBatchesRouteWithChildren
  '/academics/courses': typeof AuthedAcademicsCoursesRouteWithChildren
  '/academics/exams': typeof AuthedAcademicsExamsRouteWithChildren
  '/academics/leave': typeof AuthedAcademicsLeaveRoute
  '/academics/meetings': typeof AuthedAcademicsMeetingsRouteWithChildren
  '/academics/progress': typeof AuthedAcademicsProgressRoute
  '/academics/report-leaderboard': typeof AuthedAcademicsReportLeaderboardRoute
  '/academics/report-review': typeof AuthedAcademicsReportReviewRoute
  '/academics/resources': typeof AuthedAcademicsResourcesRouteWithChildren
  '/academics/weekly-sheet': typeof AuthedAcademicsWeeklySheetRoute
  '/announcements/$announcementId': typeof AuthedAnnouncementsAnnouncementIdRoute
  '/candidate/aptitude': typeof AuthedCandidateAptitudeRoute
  '/candidate/demos': typeof AuthedCandidateDemosRoute
  '/candidate/onboard': typeof AuthedCandidateOnboardRoute
  '/candidate/rules': typeof AuthedCandidateRulesRoute
  '/candidate/status': typeof AuthedCandidateStatusRoute
  '/finance/fees': typeof AuthedFinanceFeesRouteWithChildren
  '/finance/incentives': typeof AuthedFinanceIncentivesRoute
  '/finance/receipts': typeof AuthedFinanceReceiptsRouteWithChildren
  '/finance/salaries': typeof AuthedFinanceSalariesRouteWithChildren
  '/finance/withdrawals': typeof AuthedFinanceWithdrawalsRouteWithChildren
  '/games/$runId': typeof AuthedGamesRunIdRoute
  '/hr/applications': typeof AuthedHrApplicationsRouteWithChildren
  '/hr/feedback': typeof AuthedHrFeedbackRouteWithChildren
  '/hr/interviews': typeof AuthedHrInterviewsRouteWithChildren
  '/hr/performance': typeof AuthedHrPerformanceRouteWithChildren
  '/hr/probation': typeof AuthedHrProbationRouteWithChildren
  '/me/assessments': typeof AuthedMeAssessmentsRoute
  '/me/attendance': typeof AuthedMeAttendanceRoute
  '/me/children': typeof AuthedMeChildrenRouteWithChildren
  '/me/feedback': typeof AuthedMeFeedbackRoute
  '/me/fees': typeof AuthedMeFeesRoute
  '/me/leave': typeof AuthedMeLeaveRoute
  '/me/marks': typeof AuthedMeMarksRoute
  '/me/performance': typeof AuthedMePerformanceRoute
  '/me/points': typeof AuthedMePointsRoute
  '/me/referrals': typeof AuthedMeReferralsRoute
  '/me/reports': typeof AuthedMeReportsRoute
  '/people/households': typeof AuthedPeopleHouseholdsRouteWithChildren
  '/people/managers': typeof AuthedPeopleManagersRouteWithChildren
  '/people/students': typeof AuthedPeopleStudentsRouteWithChildren
  '/people/teachers': typeof AuthedPeopleTeachersRouteWithChildren
  '/system/audit': typeof AuthedSystemAuditRoute
  '/system/calendar': typeof AuthedSystemCalendarRoute
  '/system/feature-flags': typeof AuthedSystemFeatureFlagsRoute
  '/system/hiring-config': typeof AuthedSystemHiringConfigRoute
  '/system/performance-config': typeof AuthedSystemPerformanceConfigRoute
  '/system/scheduled-jobs': typeof AuthedSystemScheduledJobsRoute
  '/system/settings': typeof AuthedSystemSettingsRoute
  '/system/teacher-reports': typeof AuthedSystemTeacherReportsRoute
  '/system/users': typeof AuthedSystemUsersRouteWithChildren
  '/academics/assessments/$templateId': typeof AuthedAcademicsAssessmentsTemplateIdRoute
  '/academics/batches/$batchId': typeof AuthedAcademicsBatchesBatchIdRoute
  '/academics/courses/$courseId': typeof AuthedAcademicsCoursesCourseIdRoute
  '/academics/exams/$cycleId': typeof AuthedAcademicsExamsCycleIdRoute
  '/academics/meetings/$meetingId': typeof AuthedAcademicsMeetingsMeetingIdRoute
  '/academics/resources/$resourceId': typeof AuthedAcademicsResourcesResourceIdRoute
  '/assessments/attempts/$attemptId': typeof AuthedAssessmentsAttemptsAttemptIdRouteWithChildren
  '/candidate/interview/book': typeof AuthedCandidateInterviewBookRoute
  '/finance/fees/$cycleId': typeof AuthedFinanceFeesCycleIdRoute
  '/finance/fees/claims': typeof AuthedFinanceFeesClaimsRouteWithChildren
  '/finance/payslips/$paymentId': typeof AuthedFinancePayslipsPaymentIdRoute
  '/finance/receipts/$paymentId': typeof AuthedFinanceReceiptsPaymentIdRoute
  '/finance/salaries/$cycleId': typeof AuthedFinanceSalariesCycleIdRoute
  '/finance/withdrawals/$withdrawalId': typeof AuthedFinanceWithdrawalsWithdrawalIdRoute
  '/hr/applications/$applicationId': typeof AuthedHrApplicationsApplicationIdRoute
  '/hr/interviews/$slotId': typeof AuthedHrInterviewsSlotIdRoute
  '/hr/probation/$teacherId': typeof AuthedHrProbationTeacherIdRoute
  '/people/households/$householdId': typeof AuthedPeopleHouseholdsHouseholdIdRoute
  '/people/managers/$managerId': typeof AuthedPeopleManagersManagerIdRoute
  '/people/students/$studentId': typeof AuthedPeopleStudentsStudentIdRoute
  '/people/teachers/$teacherId': typeof AuthedPeopleTeachersTeacherIdRoute
  '/system/teacher-report-templates/$templateId': typeof AuthedSystemTeacherReportTemplatesTemplateIdRoute
  '/system/users/$userId': typeof AuthedSystemUsersUserIdRoute
  '/system/wallet/adjustments': typeof AuthedSystemWalletAdjustmentsRoute
  '/academics/assessments/runs/$runId': typeof AuthedAcademicsAssessmentsRunsRunIdRoute
  '/assessments/attempts/$attemptId/result': typeof AuthedAssessmentsAttemptsAttemptIdResultRoute
  '/assessments/runs/$runId/start': typeof AuthedAssessmentsRunsRunIdStartRoute
  '/finance/fees/claims/$claimId': typeof AuthedFinanceFeesClaimsClaimIdRoute
  '/finance/fees/payments/$paymentId': typeof AuthedFinanceFeesPaymentsPaymentIdRoute
  '/finance/salaries/payments/$paymentId': typeof AuthedFinanceSalariesPaymentsPaymentIdRoute
  '/hr/feedback/forms/$formId': typeof AuthedHrFeedbackFormsFormIdRoute
  '/hr/feedback/submissions/$submissionId': typeof AuthedHrFeedbackSubmissionsSubmissionIdRoute
  '/hr/feedback/teachers/$teacherId': typeof AuthedHrFeedbackTeachersTeacherIdRoute
  '/hr/performance/teachers/$teacherId': typeof AuthedHrPerformanceTeachersTeacherIdRoute
  '/me/children/$studentId/marks': typeof AuthedMeChildrenStudentIdMarksRoute
  '/me/report/$kind/$batchId/$periodKey': typeof AuthedMeReportKindBatchIdPeriodKeyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/reset': typeof ResetRoute
  '/academic-ops': typeof AuthedAcademicOpsRoute
  '/announcements': typeof AuthedAnnouncementsRouteWithChildren
  '/change-password': typeof AuthedChangePasswordRoute
  '/control-center': typeof AuthedControlCenterRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/family': typeof AuthedFamilyRoute
  '/finance-ops': typeof AuthedFinanceOpsRoute
  '/games': typeof AuthedGamesRouteWithChildren
  '/operations': typeof AuthedOperationsRoute
  '/progress': typeof AuthedProgressRoute
  '/today': typeof AuthedTodayRoute
  '/academics/assessments': typeof AuthedAcademicsAssessmentsRouteWithChildren
  '/academics/attendance': typeof AuthedAcademicsAttendanceRoute
  '/academics/batches': typeof AuthedAcademicsBatchesRouteWithChildren
  '/academics/courses': typeof AuthedAcademicsCoursesRouteWithChildren
  '/academics/exams': typeof AuthedAcademicsExamsRouteWithChildren
  '/academics/leave': typeof AuthedAcademicsLeaveRoute
  '/academics/meetings': typeof AuthedAcademicsMeetingsRouteWithChildren
  '/academics/progress': typeof AuthedAcademicsProgressRoute
  '/academics/report-leaderboard': typeof AuthedAcademicsReportLeaderboardRoute
  '/academics/report-review': typeof AuthedAcademicsReportReviewRoute
  '/academics/resources': typeof AuthedAcademicsResourcesRouteWithChildren
  '/academics/weekly-sheet': typeof AuthedAcademicsWeeklySheetRoute
  '/announcements/$announcementId': typeof AuthedAnnouncementsAnnouncementIdRoute
  '/candidate/aptitude': typeof AuthedCandidateAptitudeRoute
  '/candidate/demos': typeof AuthedCandidateDemosRoute
  '/candidate/onboard': typeof AuthedCandidateOnboardRoute
  '/candidate/rules': typeof AuthedCandidateRulesRoute
  '/candidate/status': typeof AuthedCandidateStatusRoute
  '/finance/fees': typeof AuthedFinanceFeesRouteWithChildren
  '/finance/incentives': typeof AuthedFinanceIncentivesRoute
  '/finance/receipts': typeof AuthedFinanceReceiptsRouteWithChildren
  '/finance/salaries': typeof AuthedFinanceSalariesRouteWithChildren
  '/finance/withdrawals': typeof AuthedFinanceWithdrawalsRouteWithChildren
  '/games/$runId': typeof AuthedGamesRunIdRoute
  '/hr/applications': typeof AuthedHrApplicationsRouteWithChildren
  '/hr/feedback': typeof AuthedHrFeedbackRouteWithChildren
  '/hr/interviews': typeof AuthedHrInterviewsRouteWithChildren
  '/hr/performance': typeof AuthedHrPerformanceRouteWithChildren
  '/hr/probation': typeof AuthedHrProbationRouteWithChildren
  '/me/assessments': typeof AuthedMeAssessmentsRoute
  '/me/attendance': typeof AuthedMeAttendanceRoute
  '/me/children': typeof AuthedMeChildrenRouteWithChildren
  '/me/feedback': typeof AuthedMeFeedbackRoute
  '/me/fees': typeof AuthedMeFeesRoute
  '/me/leave': typeof AuthedMeLeaveRoute
  '/me/marks': typeof AuthedMeMarksRoute
  '/me/performance': typeof AuthedMePerformanceRoute
  '/me/points': typeof AuthedMePointsRoute
  '/me/referrals': typeof AuthedMeReferralsRoute
  '/me/reports': typeof AuthedMeReportsRoute
  '/people/households': typeof AuthedPeopleHouseholdsRouteWithChildren
  '/people/managers': typeof AuthedPeopleManagersRouteWithChildren
  '/people/students': typeof AuthedPeopleStudentsRouteWithChildren
  '/people/teachers': typeof AuthedPeopleTeachersRouteWithChildren
  '/system/audit': typeof AuthedSystemAuditRoute
  '/system/calendar': typeof AuthedSystemCalendarRoute
  '/system/feature-flags': typeof AuthedSystemFeatureFlagsRoute
  '/system/hiring-config': typeof AuthedSystemHiringConfigRoute
  '/system/performance-config': typeof AuthedSystemPerformanceConfigRoute
  '/system/scheduled-jobs': typeof AuthedSystemScheduledJobsRoute
  '/system/settings': typeof AuthedSystemSettingsRoute
  '/system/teacher-reports': typeof AuthedSystemTeacherReportsRoute
  '/system/users': typeof AuthedSystemUsersRouteWithChildren
  '/academics/assessments/$templateId': typeof AuthedAcademicsAssessmentsTemplateIdRoute
  '/academics/batches/$batchId': typeof AuthedAcademicsBatchesBatchIdRoute
  '/academics/courses/$courseId': typeof AuthedAcademicsCoursesCourseIdRoute
  '/academics/exams/$cycleId': typeof AuthedAcademicsExamsCycleIdRoute
  '/academics/meetings/$meetingId': typeof AuthedAcademicsMeetingsMeetingIdRoute
  '/academics/resources/$resourceId': typeof AuthedAcademicsResourcesResourceIdRoute
  '/assessments/attempts/$attemptId': typeof AuthedAssessmentsAttemptsAttemptIdRouteWithChildren
  '/candidate/interview/book': typeof AuthedCandidateInterviewBookRoute
  '/finance/fees/$cycleId': typeof AuthedFinanceFeesCycleIdRoute
  '/finance/fees/claims': typeof AuthedFinanceFeesClaimsRouteWithChildren
  '/finance/payslips/$paymentId': typeof AuthedFinancePayslipsPaymentIdRoute
  '/finance/receipts/$paymentId': typeof AuthedFinanceReceiptsPaymentIdRoute
  '/finance/salaries/$cycleId': typeof AuthedFinanceSalariesCycleIdRoute
  '/finance/withdrawals/$withdrawalId': typeof AuthedFinanceWithdrawalsWithdrawalIdRoute
  '/hr/applications/$applicationId': typeof AuthedHrApplicationsApplicationIdRoute
  '/hr/interviews/$slotId': typeof AuthedHrInterviewsSlotIdRoute
  '/hr/probation/$teacherId': typeof AuthedHrProbationTeacherIdRoute
  '/people/households/$householdId': typeof AuthedPeopleHouseholdsHouseholdIdRoute
  '/people/managers/$managerId': typeof AuthedPeopleManagersManagerIdRoute
  '/people/students/$studentId': typeof AuthedPeopleStudentsStudentIdRoute
  '/people/teachers/$teacherId': typeof AuthedPeopleTeachersTeacherIdRoute
  '/system/teacher-report-templates/$templateId': typeof AuthedSystemTeacherReportTemplatesTemplateIdRoute
  '/system/users/$userId': typeof AuthedSystemUsersUserIdRoute
  '/system/wallet/adjustments': typeof AuthedSystemWalletAdjustmentsRoute
  '/academics/assessments/runs/$runId': typeof AuthedAcademicsAssessmentsRunsRunIdRoute
  '/assessments/attempts/$attemptId/result': typeof AuthedAssessmentsAttemptsAttemptIdResultRoute
  '/assessments/runs/$runId/start': typeof AuthedAssessmentsRunsRunIdStartRoute
  '/finance/fees/claims/$claimId': typeof AuthedFinanceFeesClaimsClaimIdRoute
  '/finance/fees/payments/$paymentId': typeof AuthedFinanceFeesPaymentsPaymentIdRoute
  '/finance/salaries/payments/$paymentId': typeof AuthedFinanceSalariesPaymentsPaymentIdRoute
  '/hr/feedback/forms/$formId': typeof AuthedHrFeedbackFormsFormIdRoute
  '/hr/feedback/submissions/$submissionId': typeof AuthedHrFeedbackSubmissionsSubmissionIdRoute
  '/hr/feedback/teachers/$teacherId': typeof AuthedHrFeedbackTeachersTeacherIdRoute
  '/hr/performance/teachers/$teacherId': typeof AuthedHrPerformanceTeachersTeacherIdRoute
  '/me/children/$studentId/marks': typeof AuthedMeChildrenStudentIdMarksRoute
  '/me/report/$kind/$batchId/$periodKey': typeof AuthedMeReportKindBatchIdPeriodKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/activate': typeof ActivateRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/reset': typeof ResetRoute
  '/_authed/academic-ops': typeof AuthedAcademicOpsRoute
  '/_authed/announcements': typeof AuthedAnnouncementsRouteWithChildren
  '/_authed/change-password': typeof AuthedChangePasswordRoute
  '/_authed/control-center': typeof AuthedControlCenterRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/family': typeof AuthedFamilyRoute
  '/_authed/finance-ops': typeof AuthedFinanceOpsRoute
  '/_authed/games': typeof AuthedGamesRouteWithChildren
  '/_authed/operations': typeof AuthedOperationsRoute
  '/_authed/progress': typeof AuthedProgressRoute
  '/_authed/today': typeof AuthedTodayRoute
  '/_authed/academics/assessments': typeof AuthedAcademicsAssessmentsRouteWithChildren
  '/_authed/academics/attendance': typeof AuthedAcademicsAttendanceRoute
  '/_authed/academics/batches': typeof AuthedAcademicsBatchesRouteWithChildren
  '/_authed/academics/courses': typeof AuthedAcademicsCoursesRouteWithChildren
  '/_authed/academics/exams': typeof AuthedAcademicsExamsRouteWithChildren
  '/_authed/academics/leave': typeof AuthedAcademicsLeaveRoute
  '/_authed/academics/meetings': typeof AuthedAcademicsMeetingsRouteWithChildren
  '/_authed/academics/progress': typeof AuthedAcademicsProgressRoute
  '/_authed/academics/report-leaderboard': typeof AuthedAcademicsReportLeaderboardRoute
  '/_authed/academics/report-review': typeof AuthedAcademicsReportReviewRoute
  '/_authed/academics/resources': typeof AuthedAcademicsResourcesRouteWithChildren
  '/_authed/academics/weekly-sheet': typeof AuthedAcademicsWeeklySheetRoute
  '/_authed/announcements/$announcementId': typeof AuthedAnnouncementsAnnouncementIdRoute
  '/_authed/candidate/aptitude': typeof AuthedCandidateAptitudeRoute
  '/_authed/candidate/demos': typeof AuthedCandidateDemosRoute
  '/_authed/candidate/onboard': typeof AuthedCandidateOnboardRoute
  '/_authed/candidate/rules': typeof AuthedCandidateRulesRoute
  '/_authed/candidate/status': typeof AuthedCandidateStatusRoute
  '/_authed/finance/fees': typeof AuthedFinanceFeesRouteWithChildren
  '/_authed/finance/incentives': typeof AuthedFinanceIncentivesRoute
  '/_authed/finance/receipts': typeof AuthedFinanceReceiptsRouteWithChildren
  '/_authed/finance/salaries': typeof AuthedFinanceSalariesRouteWithChildren
  '/_authed/finance/withdrawals': typeof AuthedFinanceWithdrawalsRouteWithChildren
  '/_authed/games/$runId': typeof AuthedGamesRunIdRoute
  '/_authed/hr/applications': typeof AuthedHrApplicationsRouteWithChildren
  '/_authed/hr/feedback': typeof AuthedHrFeedbackRouteWithChildren
  '/_authed/hr/interviews': typeof AuthedHrInterviewsRouteWithChildren
  '/_authed/hr/performance': typeof AuthedHrPerformanceRouteWithChildren
  '/_authed/hr/probation': typeof AuthedHrProbationRouteWithChildren
  '/_authed/me/assessments': typeof AuthedMeAssessmentsRoute
  '/_authed/me/attendance': typeof AuthedMeAttendanceRoute
  '/_authed/me/children': typeof AuthedMeChildrenRouteWithChildren
  '/_authed/me/feedback': typeof AuthedMeFeedbackRoute
  '/_authed/me/fees': typeof AuthedMeFeesRoute
  '/_authed/me/leave': typeof AuthedMeLeaveRoute
  '/_authed/me/marks': typeof AuthedMeMarksRoute
  '/_authed/me/performance': typeof AuthedMePerformanceRoute
  '/_authed/me/points': typeof AuthedMePointsRoute
  '/_authed/me/referrals': typeof AuthedMeReferralsRoute
  '/_authed/me/reports': typeof AuthedMeReportsRoute
  '/_authed/people/households': typeof AuthedPeopleHouseholdsRouteWithChildren
  '/_authed/people/managers': typeof AuthedPeopleManagersRouteWithChildren
  '/_authed/people/students': typeof AuthedPeopleStudentsRouteWithChildren
  '/_authed/people/teachers': typeof AuthedPeopleTeachersRouteWithChildren
  '/_authed/system/audit': typeof AuthedSystemAuditRoute
  '/_authed/system/calendar': typeof AuthedSystemCalendarRoute
  '/_authed/system/feature-flags': typeof AuthedSystemFeatureFlagsRoute
  '/_authed/system/hiring-config': typeof AuthedSystemHiringConfigRoute
  '/_authed/system/performance-config': typeof AuthedSystemPerformanceConfigRoute
  '/_authed/system/scheduled-jobs': typeof AuthedSystemScheduledJobsRoute
  '/_authed/system/settings': typeof AuthedSystemSettingsRoute
  '/_authed/system/teacher-reports': typeof AuthedSystemTeacherReportsRoute
  '/_authed/system/users': typeof AuthedSystemUsersRouteWithChildren
  '/_authed/academics/assessments/$templateId': typeof AuthedAcademicsAssessmentsTemplateIdRoute
  '/_authed/academics/batches/$batchId': typeof AuthedAcademicsBatchesBatchIdRoute
  '/_authed/academics/courses/$courseId': typeof AuthedAcademicsCoursesCourseIdRoute
  '/_authed/academics/exams/$cycleId': typeof AuthedAcademicsExamsCycleIdRoute
  '/_authed/academics/meetings/$meetingId': typeof AuthedAcademicsMeetingsMeetingIdRoute
  '/_authed/academics/resources/$resourceId': typeof AuthedAcademicsResourcesResourceIdRoute
  '/_authed/assessments/attempts/$attemptId': typeof AuthedAssessmentsAttemptsAttemptIdRouteWithChildren
  '/_authed/candidate/interview/book': typeof AuthedCandidateInterviewBookRoute
  '/_authed/finance/fees/$cycleId': typeof AuthedFinanceFeesCycleIdRoute
  '/_authed/finance/fees/claims': typeof AuthedFinanceFeesClaimsRouteWithChildren
  '/_authed/finance/payslips/$paymentId': typeof AuthedFinancePayslipsPaymentIdRoute
  '/_authed/finance/receipts/$paymentId': typeof AuthedFinanceReceiptsPaymentIdRoute
  '/_authed/finance/salaries/$cycleId': typeof AuthedFinanceSalariesCycleIdRoute
  '/_authed/finance/withdrawals/$withdrawalId': typeof AuthedFinanceWithdrawalsWithdrawalIdRoute
  '/_authed/hr/applications/$applicationId': typeof AuthedHrApplicationsApplicationIdRoute
  '/_authed/hr/interviews/$slotId': typeof AuthedHrInterviewsSlotIdRoute
  '/_authed/hr/probation/$teacherId': typeof AuthedHrProbationTeacherIdRoute
  '/_authed/people/households/$householdId': typeof AuthedPeopleHouseholdsHouseholdIdRoute
  '/_authed/people/managers/$managerId': typeof AuthedPeopleManagersManagerIdRoute
  '/_authed/people/students/$studentId': typeof AuthedPeopleStudentsStudentIdRoute
  '/_authed/people/teachers/$teacherId': typeof AuthedPeopleTeachersTeacherIdRoute
  '/_authed/system/teacher-report-templates/$templateId': typeof AuthedSystemTeacherReportTemplatesTemplateIdRoute
  '/_authed/system/users/$userId': typeof AuthedSystemUsersUserIdRoute
  '/_authed/system/wallet/adjustments': typeof AuthedSystemWalletAdjustmentsRoute
  '/_authed/academics/assessments/runs/$runId': typeof AuthedAcademicsAssessmentsRunsRunIdRoute
  '/_authed/assessments/attempts/$attemptId/result': typeof AuthedAssessmentsAttemptsAttemptIdResultRoute
  '/_authed/assessments/runs/$runId/start': typeof AuthedAssessmentsRunsRunIdStartRoute
  '/_authed/finance/fees/claims/$claimId': typeof AuthedFinanceFeesClaimsClaimIdRoute
  '/_authed/finance/fees/payments/$paymentId': typeof AuthedFinanceFeesPaymentsPaymentIdRoute
  '/_authed/finance/salaries/payments/$paymentId': typeof AuthedFinanceSalariesPaymentsPaymentIdRoute
  '/_authed/hr/feedback/forms/$formId': typeof AuthedHrFeedbackFormsFormIdRoute
  '/_authed/hr/feedback/submissions/$submissionId': typeof AuthedHrFeedbackSubmissionsSubmissionIdRoute
  '/_authed/hr/feedback/teachers/$teacherId': typeof AuthedHrFeedbackTeachersTeacherIdRoute
  '/_authed/hr/performance/teachers/$teacherId': typeof AuthedHrPerformanceTeachersTeacherIdRoute
  '/_authed/me/children/$studentId/marks': typeof AuthedMeChildrenStudentIdMarksRoute
  '/_authed/me/report/$kind/$batchId/$periodKey': typeof AuthedMeReportKindBatchIdPeriodKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/forgot'
    | '/login'
    | '/otp'
    | '/reset'
    | '/academic-ops'
    | '/announcements'
    | '/change-password'
    | '/control-center'
    | '/dashboard'
    | '/family'
    | '/finance-ops'
    | '/games'
    | '/operations'
    | '/progress'
    | '/today'
    | '/academics/assessments'
    | '/academics/attendance'
    | '/academics/batches'
    | '/academics/courses'
    | '/academics/exams'
    | '/academics/leave'
    | '/academics/meetings'
    | '/academics/progress'
    | '/academics/report-leaderboard'
    | '/academics/report-review'
    | '/academics/resources'
    | '/academics/weekly-sheet'
    | '/announcements/$announcementId'
    | '/candidate/aptitude'
    | '/candidate/demos'
    | '/candidate/onboard'
    | '/candidate/rules'
    | '/candidate/status'
    | '/finance/fees'
    | '/finance/incentives'
    | '/finance/receipts'
    | '/finance/salaries'
    | '/finance/withdrawals'
    | '/games/$runId'
    | '/hr/applications'
    | '/hr/feedback'
    | '/hr/interviews'
    | '/hr/performance'
    | '/hr/probation'
    | '/me/assessments'
    | '/me/attendance'
    | '/me/children'
    | '/me/feedback'
    | '/me/fees'
    | '/me/leave'
    | '/me/marks'
    | '/me/performance'
    | '/me/points'
    | '/me/referrals'
    | '/me/reports'
    | '/people/households'
    | '/people/managers'
    | '/people/students'
    | '/people/teachers'
    | '/system/audit'
    | '/system/calendar'
    | '/system/feature-flags'
    | '/system/hiring-config'
    | '/system/performance-config'
    | '/system/scheduled-jobs'
    | '/system/settings'
    | '/system/teacher-reports'
    | '/system/users'
    | '/academics/assessments/$templateId'
    | '/academics/batches/$batchId'
    | '/academics/courses/$courseId'
    | '/academics/exams/$cycleId'
    | '/academics/meetings/$meetingId'
    | '/academics/resources/$resourceId'
    | '/assessments/attempts/$attemptId'
    | '/candidate/interview/book'
    | '/finance/fees/$cycleId'
    | '/finance/fees/claims'
    | '/finance/payslips/$paymentId'
    | '/finance/receipts/$paymentId'
    | '/finance/salaries/$cycleId'
    | '/finance/withdrawals/$withdrawalId'
    | '/hr/applications/$applicationId'
    | '/hr/interviews/$slotId'
    | '/hr/probation/$teacherId'
    | '/people/households/$householdId'
    | '/people/managers/$managerId'
    | '/people/students/$studentId'
    | '/people/teachers/$teacherId'
    | '/system/teacher-report-templates/$templateId'
    | '/system/users/$userId'
    | '/system/wallet/adjustments'
    | '/academics/assessments/runs/$runId'
    | '/assessments/attempts/$attemptId/result'
    | '/assessments/runs/$runId/start'
    | '/finance/fees/claims/$claimId'
    | '/finance/fees/payments/$paymentId'
    | '/finance/salaries/payments/$paymentId'
    | '/hr/feedback/forms/$formId'
    | '/hr/feedback/submissions/$submissionId'
    | '/hr/feedback/teachers/$teacherId'
    | '/hr/performance/teachers/$teacherId'
    | '/me/children/$studentId/marks'
    | '/me/report/$kind/$batchId/$periodKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/forgot'
    | '/login'
    | '/otp'
    | '/reset'
    | '/academic-ops'
    | '/announcements'
    | '/change-password'
    | '/control-center'
    | '/dashboard'
    | '/family'
    | '/finance-ops'
    | '/games'
    | '/operations'
    | '/progress'
    | '/today'
    | '/academics/assessments'
    | '/academics/attendance'
    | '/academics/batches'
    | '/academics/courses'
    | '/academics/exams'
    | '/academics/leave'
    | '/academics/meetings'
    | '/academics/progress'
    | '/academics/report-leaderboard'
    | '/academics/report-review'
    | '/academics/resources'
    | '/academics/weekly-sheet'
    | '/announcements/$announcementId'
    | '/candidate/aptitude'
    | '/candidate/demos'
    | '/candidate/onboard'
    | '/candidate/rules'
    | '/candidate/status'
    | '/finance/fees'
    | '/finance/incentives'
    | '/finance/receipts'
    | '/finance/salaries'
    | '/finance/withdrawals'
    | '/games/$runId'
    | '/hr/applications'
    | '/hr/feedback'
    | '/hr/interviews'
    | '/hr/performance'
    | '/hr/probation'
    | '/me/assessments'
    | '/me/attendance'
    | '/me/children'
    | '/me/feedback'
    | '/me/fees'
    | '/me/leave'
    | '/me/marks'
    | '/me/performance'
    | '/me/points'
    | '/me/referrals'
    | '/me/reports'
    | '/people/households'
    | '/people/managers'
    | '/people/students'
    | '/people/teachers'
    | '/system/audit'
    | '/system/calendar'
    | '/system/feature-flags'
    | '/system/hiring-config'
    | '/system/performance-config'
    | '/system/scheduled-jobs'
    | '/system/settings'
    | '/system/teacher-reports'
    | '/system/users'
    | '/academics/assessments/$templateId'
    | '/academics/batches/$batchId'
    | '/academics/courses/$courseId'
    | '/academics/exams/$cycleId'
    | '/academics/meetings/$meetingId'
    | '/academics/resources/$resourceId'
    | '/assessments/attempts/$attemptId'
    | '/candidate/interview/book'
    | '/finance/fees/$cycleId'
    | '/finance/fees/claims'
    | '/finance/payslips/$paymentId'
    | '/finance/receipts/$paymentId'
    | '/finance/salaries/$cycleId'
    | '/finance/withdrawals/$withdrawalId'
    | '/hr/applications/$applicationId'
    | '/hr/interviews/$slotId'
    | '/hr/probation/$teacherId'
    | '/people/households/$householdId'
    | '/people/managers/$managerId'
    | '/people/students/$studentId'
    | '/people/teachers/$teacherId'
    | '/system/teacher-report-templates/$templateId'
    | '/system/users/$userId'
    | '/system/wallet/adjustments'
    | '/academics/assessments/runs/$runId'
    | '/assessments/attempts/$attemptId/result'
    | '/assessments/runs/$runId/start'
    | '/finance/fees/claims/$claimId'
    | '/finance/fees/payments/$paymentId'
    | '/finance/salaries/payments/$paymentId'
    | '/hr/feedback/forms/$formId'
    | '/hr/feedback/submissions/$submissionId'
    | '/hr/feedback/teachers/$teacherId'
    | '/hr/performance/teachers/$teacherId'
    | '/me/children/$studentId/marks'
    | '/me/report/$kind/$batchId/$periodKey'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/activate'
    | '/forgot'
    | '/login'
    | '/otp'
    | '/reset'
    | '/_authed/academic-ops'
    | '/_authed/announcements'
    | '/_authed/change-password'
    | '/_authed/control-center'
    | '/_authed/dashboard'
    | '/_authed/family'
    | '/_authed/finance-ops'
    | '/_authed/games'
    | '/_authed/operations'
    | '/_authed/progress'
    | '/_authed/today'
    | '/_authed/academics/assessments'
    | '/_authed/academics/attendance'
    | '/_authed/academics/batches'
    | '/_authed/academics/courses'
    | '/_authed/academics/exams'
    | '/_authed/academics/leave'
    | '/_authed/academics/meetings'
    | '/_authed/academics/progress'
    | '/_authed/academics/report-leaderboard'
    | '/_authed/academics/report-review'
    | '/_authed/academics/resources'
    | '/_authed/academics/weekly-sheet'
    | '/_authed/announcements/$announcementId'
    | '/_authed/candidate/aptitude'
    | '/_authed/candidate/demos'
    | '/_authed/candidate/onboard'
    | '/_authed/candidate/rules'
    | '/_authed/candidate/status'
    | '/_authed/finance/fees'
    | '/_authed/finance/incentives'
    | '/_authed/finance/receipts'
    | '/_authed/finance/salaries'
    | '/_authed/finance/withdrawals'
    | '/_authed/games/$runId'
    | '/_authed/hr/applications'
    | '/_authed/hr/feedback'
    | '/_authed/hr/interviews'
    | '/_authed/hr/performance'
    | '/_authed/hr/probation'
    | '/_authed/me/assessments'
    | '/_authed/me/attendance'
    | '/_authed/me/children'
    | '/_authed/me/feedback'
    | '/_authed/me/fees'
    | '/_authed/me/leave'
    | '/_authed/me/marks'
    | '/_authed/me/performance'
    | '/_authed/me/points'
    | '/_authed/me/referrals'
    | '/_authed/me/reports'
    | '/_authed/people/households'
    | '/_authed/people/managers'
    | '/_authed/people/students'
    | '/_authed/people/teachers'
    | '/_authed/system/audit'
    | '/_authed/system/calendar'
    | '/_authed/system/feature-flags'
    | '/_authed/system/hiring-config'
    | '/_authed/system/performance-config'
    | '/_authed/system/scheduled-jobs'
    | '/_authed/system/settings'
    | '/_authed/system/teacher-reports'
    | '/_authed/system/users'
    | '/_authed/academics/assessments/$templateId'
    | '/_authed/academics/batches/$batchId'
    | '/_authed/academics/courses/$courseId'
    | '/_authed/academics/exams/$cycleId'
    | '/_authed/academics/meetings/$meetingId'
    | '/_authed/academics/resources/$resourceId'
    | '/_authed/assessments/attempts/$attemptId'
    | '/_authed/candidate/interview/book'
    | '/_authed/finance/fees/$cycleId'
    | '/_authed/finance/fees/claims'
    | '/_authed/finance/payslips/$paymentId'
    | '/_authed/finance/receipts/$paymentId'
    | '/_authed/finance/salaries/$cycleId'
    | '/_authed/finance/withdrawals/$withdrawalId'
    | '/_authed/hr/applications/$applicationId'
    | '/_authed/hr/interviews/$slotId'
    | '/_authed/hr/probation/$teacherId'
    | '/_authed/people/households/$householdId'
    | '/_authed/people/managers/$managerId'
    | '/_authed/people/students/$studentId'
    | '/_authed/people/teachers/$teacherId'
    | '/_authed/system/teacher-report-templates/$templateId'
    | '/_authed/system/users/$userId'
    | '/_authed/system/wallet/adjustments'
    | '/_authed/academics/assessments/runs/$runId'
    | '/_authed/assessments/attempts/$attemptId/result'
    | '/_authed/assessments/runs/$runId/start'
    | '/_authed/finance/fees/claims/$claimId'
    | '/_authed/finance/fees/payments/$paymentId'
    | '/_authed/finance/salaries/payments/$paymentId'
    | '/_authed/hr/feedback/forms/$formId'
    | '/_authed/hr/feedback/submissions/$submissionId'
    | '/_authed/hr/feedback/teachers/$teacherId'
    | '/_authed/hr/performance/teachers/$teacherId'
    | '/_authed/me/children/$studentId/marks'
    | '/_authed/me/report/$kind/$batchId/$periodKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  ForgotRoute: typeof ForgotRoute
  LoginRoute: typeof LoginRoute
  OtpRoute: typeof OtpRoute
  ResetRoute: typeof ResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp': {
      id: '/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof OtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/today': {
      id: '/_authed/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthedTodayRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/progress': {
      id: '/_authed/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof AuthedProgressRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/operations': {
      id: '/_authed/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthedOperationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/games': {
      id: '/_authed/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof AuthedGamesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/finance-ops': {
      id: '/_authed/finance-ops'
      path: '/finance-ops'
      fullPath: '/finance-ops'
      preLoaderRoute: typeof AuthedFinanceOpsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/family': {
      id: '/_authed/family'
      path: '/family'
      fullPath: '/family'
      preLoaderRoute: typeof AuthedFamilyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/control-center': {
      id: '/_authed/control-center'
      path: '/control-center'
      fullPath: '/control-center'
      preLoaderRoute: typeof AuthedControlCenterRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/change-password': {
      id: '/_authed/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthedChangePasswordRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/announcements': {
      id: '/_authed/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthedAnnouncementsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academic-ops': {
      id: '/_authed/academic-ops'
      path: '/academic-ops'
      fullPath: '/academic-ops'
      preLoaderRoute: typeof AuthedAcademicOpsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/users': {
      id: '/_authed/system/users'
      path: '/system/users'
      fullPath: '/system/users'
      preLoaderRoute: typeof AuthedSystemUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/teacher-reports': {
      id: '/_authed/system/teacher-reports'
      path: '/system/teacher-reports'
      fullPath: '/system/teacher-reports'
      preLoaderRoute: typeof AuthedSystemTeacherReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/settings': {
      id: '/_authed/system/settings'
      path: '/system/settings'
      fullPath: '/system/settings'
      preLoaderRoute: typeof AuthedSystemSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/scheduled-jobs': {
      id: '/_authed/system/scheduled-jobs'
      path: '/system/scheduled-jobs'
      fullPath: '/system/scheduled-jobs'
      preLoaderRoute: typeof AuthedSystemScheduledJobsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/performance-config': {
      id: '/_authed/system/performance-config'
      path: '/system/performance-config'
      fullPath: '/system/performance-config'
      preLoaderRoute: typeof AuthedSystemPerformanceConfigRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/hiring-config': {
      id: '/_authed/system/hiring-config'
      path: '/system/hiring-config'
      fullPath: '/system/hiring-config'
      preLoaderRoute: typeof AuthedSystemHiringConfigRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/feature-flags': {
      id: '/_authed/system/feature-flags'
      path: '/system/feature-flags'
      fullPath: '/system/feature-flags'
      preLoaderRoute: typeof AuthedSystemFeatureFlagsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/calendar': {
      id: '/_authed/system/calendar'
      path: '/system/calendar'
      fullPath: '/system/calendar'
      preLoaderRoute: typeof AuthedSystemCalendarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/audit': {
      id: '/_authed/system/audit'
      path: '/system/audit'
      fullPath: '/system/audit'
      preLoaderRoute: typeof AuthedSystemAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/teachers': {
      id: '/_authed/people/teachers'
      path: '/people/teachers'
      fullPath: '/people/teachers'
      preLoaderRoute: typeof AuthedPeopleTeachersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/students': {
      id: '/_authed/people/students'
      path: '/people/students'
      fullPath: '/people/students'
      preLoaderRoute: typeof AuthedPeopleStudentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/managers': {
      id: '/_authed/people/managers'
      path: '/people/managers'
      fullPath: '/people/managers'
      preLoaderRoute: typeof AuthedPeopleManagersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/households': {
      id: '/_authed/people/households'
      path: '/people/households'
      fullPath: '/people/households'
      preLoaderRoute: typeof AuthedPeopleHouseholdsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/reports': {
      id: '/_authed/me/reports'
      path: '/me/reports'
      fullPath: '/me/reports'
      preLoaderRoute: typeof AuthedMeReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/referrals': {
      id: '/_authed/me/referrals'
      path: '/me/referrals'
      fullPath: '/me/referrals'
      preLoaderRoute: typeof AuthedMeReferralsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/points': {
      id: '/_authed/me/points'
      path: '/me/points'
      fullPath: '/me/points'
      preLoaderRoute: typeof AuthedMePointsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/performance': {
      id: '/_authed/me/performance'
      path: '/me/performance'
      fullPath: '/me/performance'
      preLoaderRoute: typeof AuthedMePerformanceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/marks': {
      id: '/_authed/me/marks'
      path: '/me/marks'
      fullPath: '/me/marks'
      preLoaderRoute: typeof AuthedMeMarksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/leave': {
      id: '/_authed/me/leave'
      path: '/me/leave'
      fullPath: '/me/leave'
      preLoaderRoute: typeof AuthedMeLeaveRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/fees': {
      id: '/_authed/me/fees'
      path: '/me/fees'
      fullPath: '/me/fees'
      preLoaderRoute: typeof AuthedMeFeesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/feedback': {
      id: '/_authed/me/feedback'
      path: '/me/feedback'
      fullPath: '/me/feedback'
      preLoaderRoute: typeof AuthedMeFeedbackRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/children': {
      id: '/_authed/me/children'
      path: '/me/children'
      fullPath: '/me/children'
      preLoaderRoute: typeof AuthedMeChildrenRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/attendance': {
      id: '/_authed/me/attendance'
      path: '/me/attendance'
      fullPath: '/me/attendance'
      preLoaderRoute: typeof AuthedMeAttendanceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me/assessments': {
      id: '/_authed/me/assessments'
      path: '/me/assessments'
      fullPath: '/me/assessments'
      preLoaderRoute: typeof AuthedMeAssessmentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/hr/probation': {
      id: '/_authed/hr/probation'
      path: '/hr/probation'
      fullPath: '/hr/probation'
      preLoaderRoute: typeof AuthedHrProbationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/hr/performance': {
      id: '/_authed/hr/performance'
      path: '/hr/performance'
      fullPath: '/hr/performance'
      preLoaderRoute: typeof AuthedHrPerformanceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/hr/interviews': {
      id: '/_authed/hr/interviews'
      path: '/hr/interviews'
      fullPath: '/hr/interviews'
      preLoaderRoute: typeof AuthedHrInterviewsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/hr/feedback': {
      id: '/_authed/hr/feedback'
      path: '/hr/feedback'
      fullPath: '/hr/feedback'
      preLoaderRoute: typeof AuthedHrFeedbackRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/hr/applications': {
      id: '/_authed/hr/applications'
      path: '/hr/applications'
      fullPath: '/hr/applications'
      preLoaderRoute: typeof AuthedHrApplicationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/games/$runId': {
      id: '/_authed/games/$runId'
      path: '/$runId'
      fullPath: '/games/$runId'
      preLoaderRoute: typeof AuthedGamesRunIdRouteImport
      parentRoute: typeof AuthedGamesRoute
    }
    '/_authed/finance/withdrawals': {
      id: '/_authed/finance/withdrawals'
      path: '/finance/withdrawals'
      fullPath: '/finance/withdrawals'
      preLoaderRoute: typeof AuthedFinanceWithdrawalsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/finance/salaries': {
      id: '/_authed/finance/salaries'
      path: '/finance/salaries'
      fullPath: '/finance/salaries'
      preLoaderRoute: typeof AuthedFinanceSalariesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/finance/receipts': {
      id: '/_authed/finance/receipts'
      path: '/finance/receipts'
      fullPath: '/finance/receipts'
      preLoaderRoute: typeof AuthedFinanceReceiptsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/finance/incentives': {
      id: '/_authed/finance/incentives'
      path: '/finance/incentives'
      fullPath: '/finance/incentives'
      preLoaderRoute: typeof AuthedFinanceIncentivesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/finance/fees': {
      id: '/_authed/finance/fees'
      path: '/finance/fees'
      fullPath: '/finance/fees'
      preLoaderRoute: typeof AuthedFinanceFeesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/candidate/status': {
      id: '/_authed/candidate/status'
      path: '/candidate/status'
      fullPath: '/candidate/status'
      preLoaderRoute: typeof AuthedCandidateStatusRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/candidate/rules': {
      id: '/_authed/candidate/rules'
      path: '/candidate/rules'
      fullPath: '/candidate/rules'
      preLoaderRoute: typeof AuthedCandidateRulesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/candidate/onboard': {
      id: '/_authed/candidate/onboard'
      path: '/candidate/onboard'
      fullPath: '/candidate/onboard'
      preLoaderRoute: typeof AuthedCandidateOnboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/candidate/demos': {
      id: '/_authed/candidate/demos'
      path: '/candidate/demos'
      fullPath: '/candidate/demos'
      preLoaderRoute: typeof AuthedCandidateDemosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/candidate/aptitude': {
      id: '/_authed/candidate/aptitude'
      path: '/candidate/aptitude'
      fullPath: '/candidate/aptitude'
      preLoaderRoute: typeof AuthedCandidateAptitudeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/announcements/$announcementId': {
      id: '/_authed/announcements/$announcementId'
      path: '/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof AuthedAnnouncementsAnnouncementIdRouteImport
      parentRoute: typeof AuthedAnnouncementsRoute
    }
    '/_authed/academics/weekly-sheet': {
      id: '/_authed/academics/weekly-sheet'
      path: '/academics/weekly-sheet'
      fullPath: '/academics/weekly-sheet'
      preLoaderRoute: typeof AuthedAcademicsWeeklySheetRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/resources': {
      id: '/_authed/academics/resources'
      path: '/academics/resources'
      fullPath: '/academics/resources'
      preLoaderRoute: typeof AuthedAcademicsResourcesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/report-review': {
      id: '/_authed/academics/report-review'
      path: '/academics/report-review'
      fullPath: '/academics/report-review'
      preLoaderRoute: typeof AuthedAcademicsReportReviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/report-leaderboard': {
      id: '/_authed/academics/report-leaderboard'
      path: '/academics/report-leaderboard'
      fullPath: '/academics/report-leaderboard'
      preLoaderRoute: typeof AuthedAcademicsReportLeaderboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/progress': {
      id: '/_authed/academics/progress'
      path: '/academics/progress'
      fullPath: '/academics/progress'
      preLoaderRoute: typeof AuthedAcademicsProgressRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/meetings': {
      id: '/_authed/academics/meetings'
      path: '/academics/meetings'
      fullPath: '/academics/meetings'
      preLoaderRoute: typeof AuthedAcademicsMeetingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/leave': {
      id: '/_authed/academics/leave'
      path: '/academics/leave'
      fullPath: '/academics/leave'
      preLoaderRoute: typeof AuthedAcademicsLeaveRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/exams': {
      id: '/_authed/academics/exams'
      path: '/academics/exams'
      fullPath: '/academics/exams'
      preLoaderRoute: typeof AuthedAcademicsExamsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/courses': {
      id: '/_authed/academics/courses'
      path: '/academics/courses'
      fullPath: '/academics/courses'
      preLoaderRoute: typeof AuthedAcademicsCoursesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/batches': {
      id: '/_authed/academics/batches'
      path: '/academics/batches'
      fullPath: '/academics/batches'
      preLoaderRoute: typeof AuthedAcademicsBatchesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/attendance': {
      id: '/_authed/academics/attendance'
      path: '/academics/attendance'
      fullPath: '/academics/attendance'
      preLoaderRoute: typeof AuthedAcademicsAttendanceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/assessments': {
      id: '/_authed/academics/assessments'
      path: '/academics/assessments'
      fullPath: '/academics/assessments'
      preLoaderRoute: typeof AuthedAcademicsAssessmentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/wallet/adjustments': {
      id: '/_authed/system/wallet/adjustments'
      path: '/system/wallet/adjustments'
      fullPath: '/system/wallet/adjustments'
      preLoaderRoute: typeof AuthedSystemWalletAdjustmentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/users/$userId': {
      id: '/_authed/system/users/$userId'
      path: '/$userId'
      fullPath: '/system/users/$userId'
      preLoaderRoute: typeof AuthedSystemUsersUserIdRouteImport
      parentRoute: typeof AuthedSystemUsersRoute
    }
    '/_authed/system/teacher-report-templates/$templateId': {
      id: '/_authed/system/teacher-report-templates/$templateId'
      path: '/system/teacher-report-templates/$templateId'
      fullPath: '/system/teacher-report-templates/$templateId'
      preLoaderRoute: typeof AuthedSystemTeacherReportTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/teachers/$teacherId': {
      id: '/_authed/people/teachers/$teacherId'
      path: '/$teacherId'
      fullPath: '/people/teachers/$teacherId'
      preLoaderRoute: typeof AuthedPeopleTeachersTeacherIdRouteImport
      parentRoute: typeof AuthedPeopleTeachersRoute
    }
    '/_authed/people/students/$studentId': {
      id: '/_authed/people/students/$studentId'
      path: '/$studentId'
      fullPath: '/people/students/$studentId'
      preLoaderRoute: typeof AuthedPeopleStudentsStudentIdRouteImport
      parentRoute: typeof AuthedPeopleStudentsRoute
    }
    '/_authed/people/managers/$managerId': {
      id: '/_authed/people/managers/$managerId'
      path: '/$managerId'
      fullPath: '/people/managers/$managerId'
      preLoaderRoute: typeof AuthedPeopleManagersManagerIdRouteImport
      parentRoute: typeof AuthedPeopleManagersRoute
    }
    '/_authed/people/households/$householdId': {
      id: '/_authed/people/households/$householdId'
      path: '/$householdId'
      fullPath: '/people/households/$householdId'
      preLoaderRoute: typeof AuthedPeopleHouseholdsHouseholdIdRouteImport
      parentRoute: typeof AuthedPeopleHouseholdsRoute
    }
    '/_authed/hr/probation/$teacherId': {
      id: '/_authed/hr/probation/$teacherId'
      path: '/$teacherId'
      fullPath: '/hr/probation/$teacherId'
      preLoaderRoute: typeof AuthedHrProbationTeacherIdRouteImport
      parentRoute: typeof AuthedHrProbationRoute
    }
    '/_authed/hr/interviews/$slotId': {
      id: '/_authed/hr/interviews/$slotId'
      path: '/$slotId'
      fullPath: '/hr/interviews/$slotId'
      preLoaderRoute: typeof AuthedHrInterviewsSlotIdRouteImport
      parentRoute: typeof AuthedHrInterviewsRoute
    }
    '/_authed/hr/applications/$applicationId': {
      id: '/_authed/hr/applications/$applicationId'
      path: '/$applicationId'
      fullPath: '/hr/applications/$applicationId'
      preLoaderRoute: typeof AuthedHrApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthedHrApplicationsRoute
    }
    '/_authed/finance/withdrawals/$withdrawalId': {
      id: '/_authed/finance/withdrawals/$withdrawalId'
      path: '/$withdrawalId'
      fullPath: '/finance/withdrawals/$withdrawalId'
      preLoaderRoute: typeof AuthedFinanceWithdrawalsWithdrawalIdRouteImport
      parentRoute: typeof AuthedFinanceWithdrawalsRoute
    }
    '/_authed/finance/salaries/$cycleId': {
      id: '/_authed/finance/salaries/$cycleId'
      path: '/$cycleId'
      fullPath: '/finance/salaries/$cycleId'
      preLoaderRoute: typeof AuthedFinanceSalariesCycleIdRouteImport
      parentRoute: typeof AuthedFinanceSalariesRoute
    }
    '/_authed/finance/receipts/$paymentId': {
      id: '/_authed/finance/receipts/$paymentId'
      path: '/$paymentId'
      fullPath: '/finance/receipts/$paymentId'
      preLoaderRoute: typeof AuthedFinanceReceiptsPaymentIdRouteImport
      parentRoute: typeof AuthedFinanceReceiptsRoute
    }
    '/_authed/finance/payslips/$paymentId': {
      id: '/_authed/finance/payslips/$paymentId'
      path: '/finance/payslips/$paymentId'
      fullPath: '/finance/payslips/$paymentId'
      preLoaderRoute: typeof AuthedFinancePayslipsPaymentIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/finance/fees/claims': {
      id: '/_authed/finance/fees/claims'
      path: '/claims'
      fullPath: '/finance/fees/claims'
      preLoaderRoute: typeof AuthedFinanceFeesClaimsRouteImport
      parentRoute: typeof AuthedFinanceFeesRoute
    }
    '/_authed/finance/fees/$cycleId': {
      id: '/_authed/finance/fees/$cycleId'
      path: '/$cycleId'
      fullPath: '/finance/fees/$cycleId'
      preLoaderRoute: typeof AuthedFinanceFeesCycleIdRouteImport
      parentRoute: typeof AuthedFinanceFeesRoute
    }
    '/_authed/candidate/interview/book': {
      id: '/_authed/candidate/interview/book'
      path: '/candidate/interview/book'
      fullPath: '/candidate/interview/book'
      preLoaderRoute: typeof AuthedCandidateInterviewBookRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assessments/attempts/$attemptId': {
      id: '/_authed/assessments/attempts/$attemptId'
      path: '/assessments/attempts/$attemptId'
      fullPath: '/assessments/attempts/$attemptId'
      preLoaderRoute: typeof AuthedAssessmentsAttemptsAttemptIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/academics/resources/$resourceId': {
      id: '/_authed/academics/resources/$resourceId'
      path: '/$resourceId'
      fullPath: '/academics/resources/$resourceId'
      preLoaderRoute: typeof AuthedAcademicsResourcesResourceIdRouteImport
      parentRoute: typeof AuthedAcademicsResourcesRoute
    }
    '/_authed/academics/meetings/$meetingId': {
      id: '/_authed/academics/meetings/$meetingId'
      path: '/$meetingId'
      fullPath: '/academics/meetings/$meetingId'
      preLoaderRoute: typeof AuthedAcademicsMeetingsMeetingIdRouteImport
      parentRoute: typeof AuthedAcademicsMeetingsRoute
    }
    '/_authed/academics/exams/$cycleId': {
      id: '/_authed/academics/exams/$cycleId'
      path: '/$cycleId'
      fullPath: '/academics/exams/$cycleId'
      preLoaderRoute: typeof AuthedAcademicsExamsCycleIdRouteImport
      parentRoute: typeof AuthedAcademicsExamsRoute
    }
    '/_authed/academics/courses/$courseId': {
      id: '/_authed/academics/courses/$courseId'
      path: '/$courseId'
      fullPath: '/academics/courses/$courseId'
      preLoaderRoute: typeof AuthedAcademicsCoursesCourseIdRouteImport
      parentRoute: typeof AuthedAcademicsCoursesRoute
    }
    '/_authed/academics/batches/$batchId': {
      id: '/_authed/academics/batches/$batchId'
      path: '/$batchId'
      fullPath: '/academics/batches/$batchId'
      preLoaderRoute: typeof AuthedAcademicsBatchesBatchIdRouteImport
      parentRoute: typeof AuthedAcademicsBatchesRoute
    }
    '/_authed/academics/assessments/$templateId': {
      id: '/_authed/academics/assessments/$templateId'
      path: '/$templateId'
      fullPath: '/academics/assessments/$templateId'
      preLoaderRoute: typeof AuthedAcademicsAssessmentsTemplateIdRouteImport
      parentRoute: typeof AuthedAcademicsAssessmentsRoute
    }
    '/_authed/me/children/$studentId/marks': {
      id: '/_authed/me/children/$studentId/marks'
      path: '/$studentId/marks'
      fullPath: '/me/children/$studentId/marks'
      preLoaderRoute: typeof AuthedMeChildrenStudentIdMarksRouteImport
      parentRoute: typeof AuthedMeChildrenRoute
    }
    '/_authed/hr/performance/teachers/$teacherId': {
      id: '/_authed/hr/performance/teachers/$teacherId'
      path: '/teachers/$teacherId'
      fullPath: '/hr/performance/teachers/$teacherId'
      preLoaderRoute: typeof AuthedHrPerformanceTeachersTeacherIdRouteImport
      parentRoute: typeof AuthedHrPerformanceRoute
    }
    '/_authed/hr/feedback/teachers/$teacherId': {
      id: '/_authed/hr/feedback/teachers/$teacherId'
      path: '/teachers/$teacherId'
      fullPath: '/hr/feedback/teachers/$teacherId'
      preLoaderRoute: typeof AuthedHrFeedbackTeachersTeacherIdRouteImport
      parentRoute: typeof AuthedHrFeedbackRoute
    }
    '/_authed/hr/feedback/submissions/$submissionId': {
      id: '/_authed/hr/feedback/submissions/$submissionId'
      path: '/submissions/$submissionId'
      fullPath: '/hr/feedback/submissions/$submissionId'
      preLoaderRoute: typeof AuthedHrFeedbackSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthedHrFeedbackRoute
    }
    '/_authed/hr/feedback/forms/$formId': {
      id: '/_authed/hr/feedback/forms/$formId'
      path: '/forms/$formId'
      fullPath: '/hr/feedback/forms/$formId'
      preLoaderRoute: typeof AuthedHrFeedbackFormsFormIdRouteImport
      parentRoute: typeof AuthedHrFeedbackRoute
    }
    '/_authed/finance/salaries/payments/$paymentId': {
      id: '/_authed/finance/salaries/payments/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/finance/salaries/payments/$paymentId'
      preLoaderRoute: typeof AuthedFinanceSalariesPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthedFinanceSalariesRoute
    }
    '/_authed/finance/fees/payments/$paymentId': {
      id: '/_authed/finance/fees/payments/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/finance/fees/payments/$paymentId'
      preLoaderRoute: typeof AuthedFinanceFeesPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthedFinanceFeesRoute
    }
    '/_authed/finance/fees/claims/$claimId': {
      id: '/_authed/finance/fees/claims/$claimId'
      path: '/$claimId'
      fullPath: '/finance/fees/claims/$claimId'
      preLoaderRoute: typeof AuthedFinanceFeesClaimsClaimIdRouteImport
      parentRoute: typeof AuthedFinanceFeesClaimsRoute
    }
    '/_authed/assessments/runs/$runId/start': {
      id: '/_authed/assessments/runs/$runId/start'
      path: '/assessments/runs/$runId/start'
      fullPath: '/assessments/runs/$runId/start'
      preLoaderRoute: typeof AuthedAssessmentsRunsRunIdStartRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assessments/attempts/$attemptId/result': {
      id: '/_authed/assessments/attempts/$attemptId/result'
      path: '/result'
      fullPath: '/assessments/attempts/$attemptId/result'
      preLoaderRoute: typeof AuthedAssessmentsAttemptsAttemptIdResultRouteImport
      parentRoute: typeof AuthedAssessmentsAttemptsAttemptIdRoute
    }
    '/_authed/academics/assessments/runs/$runId': {
      id: '/_authed/academics/assessments/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/academics/assessments/runs/$runId'
      preLoaderRoute: typeof AuthedAcademicsAssessmentsRunsRunIdRouteImport
      parentRoute: typeof AuthedAcademicsAssessmentsRoute
    }
    '/_authed/me/report/$kind/$batchId/$periodKey': {
      id: '/_authed/me/report/$kind/$batchId/$periodKey'
      path: '/me/report/$kind/$batchId/$periodKey'
      fullPath: '/me/report/$kind/$batchId/$periodKey'
      preLoaderRoute: typeof AuthedMeReportKindBatchIdPeriodKeyRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedAnnouncementsRouteChildren {
  AuthedAnnouncementsAnnouncementIdRoute: typeof AuthedAnnouncementsAnnouncementIdRoute
}

const AuthedAnnouncementsRouteChildren: AuthedAnnouncementsRouteChildren = {
  AuthedAnnouncementsAnnouncementIdRoute:
    AuthedAnnouncementsAnnouncementIdRoute,
}

const AuthedAnnouncementsRouteWithChildren =
  AuthedAnnouncementsRoute._addFileChildren(AuthedAnnouncementsRouteChildren)

interface AuthedGamesRouteChildren {
  AuthedGamesRunIdRoute: typeof AuthedGamesRunIdRoute
}

const AuthedGamesRouteChildren: AuthedGamesRouteChildren = {
  AuthedGamesRunIdRoute: AuthedGamesRunIdRoute,
}

const AuthedGamesRouteWithChildren = AuthedGamesRoute._addFileChildren(
  AuthedGamesRouteChildren,
)

interface AuthedAcademicsAssessmentsRouteChildren {
  AuthedAcademicsAssessmentsTemplateIdRoute: typeof AuthedAcademicsAssessmentsTemplateIdRoute
  AuthedAcademicsAssessmentsRunsRunIdRoute: typeof AuthedAcademicsAssessmentsRunsRunIdRoute
}

const AuthedAcademicsAssessmentsRouteChildren: AuthedAcademicsAssessmentsRouteChildren =
  {
    AuthedAcademicsAssessmentsTemplateIdRoute:
      AuthedAcademicsAssessmentsTemplateIdRoute,
    AuthedAcademicsAssessmentsRunsRunIdRoute:
      AuthedAcademicsAssessmentsRunsRunIdRoute,
  }

const AuthedAcademicsAssessmentsRouteWithChildren =
  AuthedAcademicsAssessmentsRoute._addFileChildren(
    AuthedAcademicsAssessmentsRouteChildren,
  )

interface AuthedAcademicsBatchesRouteChildren {
  AuthedAcademicsBatchesBatchIdRoute: typeof AuthedAcademicsBatchesBatchIdRoute
}

const AuthedAcademicsBatchesRouteChildren: AuthedAcademicsBatchesRouteChildren =
  {
    AuthedAcademicsBatchesBatchIdRoute: AuthedAcademicsBatchesBatchIdRoute,
  }

const AuthedAcademicsBatchesRouteWithChildren =
  AuthedAcademicsBatchesRoute._addFileChildren(
    AuthedAcademicsBatchesRouteChildren,
  )

interface AuthedAcademicsCoursesRouteChildren {
  AuthedAcademicsCoursesCourseIdRoute: typeof AuthedAcademicsCoursesCourseIdRoute
}

const AuthedAcademicsCoursesRouteChildren: AuthedAcademicsCoursesRouteChildren =
  {
    AuthedAcademicsCoursesCourseIdRoute: AuthedAcademicsCoursesCourseIdRoute,
  }

const AuthedAcademicsCoursesRouteWithChildren =
  AuthedAcademicsCoursesRoute._addFileChildren(
    AuthedAcademicsCoursesRouteChildren,
  )

interface AuthedAcademicsExamsRouteChildren {
  AuthedAcademicsExamsCycleIdRoute: typeof AuthedAcademicsExamsCycleIdRoute
}

const AuthedAcademicsExamsRouteChildren: AuthedAcademicsExamsRouteChildren = {
  AuthedAcademicsExamsCycleIdRoute: AuthedAcademicsExamsCycleIdRoute,
}

const AuthedAcademicsExamsRouteWithChildren =
  AuthedAcademicsExamsRoute._addFileChildren(AuthedAcademicsExamsRouteChildren)

interface AuthedAcademicsMeetingsRouteChildren {
  AuthedAcademicsMeetingsMeetingIdRoute: typeof AuthedAcademicsMeetingsMeetingIdRoute
}

const AuthedAcademicsMeetingsRouteChildren: AuthedAcademicsMeetingsRouteChildren =
  {
    AuthedAcademicsMeetingsMeetingIdRoute:
      AuthedAcademicsMeetingsMeetingIdRoute,
  }

const AuthedAcademicsMeetingsRouteWithChildren =
  AuthedAcademicsMeetingsRoute._addFileChildren(
    AuthedAcademicsMeetingsRouteChildren,
  )

interface AuthedAcademicsResourcesRouteChildren {
  AuthedAcademicsResourcesResourceIdRoute: typeof AuthedAcademicsResourcesResourceIdRoute
}

const AuthedAcademicsResourcesRouteChildren: AuthedAcademicsResourcesRouteChildren =
  {
    AuthedAcademicsResourcesResourceIdRoute:
      AuthedAcademicsResourcesResourceIdRoute,
  }

const AuthedAcademicsResourcesRouteWithChildren =
  AuthedAcademicsResourcesRoute._addFileChildren(
    AuthedAcademicsResourcesRouteChildren,
  )

interface AuthedFinanceFeesClaimsRouteChildren {
  AuthedFinanceFeesClaimsClaimIdRoute: typeof AuthedFinanceFeesClaimsClaimIdRoute
}

const AuthedFinanceFeesClaimsRouteChildren: AuthedFinanceFeesClaimsRouteChildren =
  {
    AuthedFinanceFeesClaimsClaimIdRoute: AuthedFinanceFeesClaimsClaimIdRoute,
  }

const AuthedFinanceFeesClaimsRouteWithChildren =
  AuthedFinanceFeesClaimsRoute._addFileChildren(
    AuthedFinanceFeesClaimsRouteChildren,
  )

interface AuthedFinanceFeesRouteChildren {
  AuthedFinanceFeesCycleIdRoute: typeof AuthedFinanceFeesCycleIdRoute
  AuthedFinanceFeesClaimsRoute: typeof AuthedFinanceFeesClaimsRouteWithChildren
  AuthedFinanceFeesPaymentsPaymentIdRoute: typeof AuthedFinanceFeesPaymentsPaymentIdRoute
}

const AuthedFinanceFeesRouteChildren: AuthedFinanceFeesRouteChildren = {
  AuthedFinanceFeesCycleIdRoute: AuthedFinanceFeesCycleIdRoute,
  AuthedFinanceFeesClaimsRoute: AuthedFinanceFeesClaimsRouteWithChildren,
  AuthedFinanceFeesPaymentsPaymentIdRoute:
    AuthedFinanceFeesPaymentsPaymentIdRoute,
}

const AuthedFinanceFeesRouteWithChildren =
  AuthedFinanceFeesRoute._addFileChildren(AuthedFinanceFeesRouteChildren)

interface AuthedFinanceReceiptsRouteChildren {
  AuthedFinanceReceiptsPaymentIdRoute: typeof AuthedFinanceReceiptsPaymentIdRoute
}

const AuthedFinanceReceiptsRouteChildren: AuthedFinanceReceiptsRouteChildren = {
  AuthedFinanceReceiptsPaymentIdRoute: AuthedFinanceReceiptsPaymentIdRoute,
}

const AuthedFinanceReceiptsRouteWithChildren =
  AuthedFinanceReceiptsRoute._addFileChildren(
    AuthedFinanceReceiptsRouteChildren,
  )

interface AuthedFinanceSalariesRouteChildren {
  AuthedFinanceSalariesCycleIdRoute: typeof AuthedFinanceSalariesCycleIdRoute
  AuthedFinanceSalariesPaymentsPaymentIdRoute: typeof AuthedFinanceSalariesPaymentsPaymentIdRoute
}

const AuthedFinanceSalariesRouteChildren: AuthedFinanceSalariesRouteChildren = {
  AuthedFinanceSalariesCycleIdRoute: AuthedFinanceSalariesCycleIdRoute,
  AuthedFinanceSalariesPaymentsPaymentIdRoute:
    AuthedFinanceSalariesPaymentsPaymentIdRoute,
}

const AuthedFinanceSalariesRouteWithChildren =
  AuthedFinanceSalariesRoute._addFileChildren(
    AuthedFinanceSalariesRouteChildren,
  )

interface AuthedFinanceWithdrawalsRouteChildren {
  AuthedFinanceWithdrawalsWithdrawalIdRoute: typeof AuthedFinanceWithdrawalsWithdrawalIdRoute
}

const AuthedFinanceWithdrawalsRouteChildren: AuthedFinanceWithdrawalsRouteChildren =
  {
    AuthedFinanceWithdrawalsWithdrawalIdRoute:
      AuthedFinanceWithdrawalsWithdrawalIdRoute,
  }

const AuthedFinanceWithdrawalsRouteWithChildren =
  AuthedFinanceWithdrawalsRoute._addFileChildren(
    AuthedFinanceWithdrawalsRouteChildren,
  )

interface AuthedHrApplicationsRouteChildren {
  AuthedHrApplicationsApplicationIdRoute: typeof AuthedHrApplicationsApplicationIdRoute
}

const AuthedHrApplicationsRouteChildren: AuthedHrApplicationsRouteChildren = {
  AuthedHrApplicationsApplicationIdRoute:
    AuthedHrApplicationsApplicationIdRoute,
}

const AuthedHrApplicationsRouteWithChildren =
  AuthedHrApplicationsRoute._addFileChildren(AuthedHrApplicationsRouteChildren)

interface AuthedHrFeedbackRouteChildren {
  AuthedHrFeedbackFormsFormIdRoute: typeof AuthedHrFeedbackFormsFormIdRoute
  AuthedHrFeedbackSubmissionsSubmissionIdRoute: typeof AuthedHrFeedbackSubmissionsSubmissionIdRoute
  AuthedHrFeedbackTeachersTeacherIdRoute: typeof AuthedHrFeedbackTeachersTeacherIdRoute
}

const AuthedHrFeedbackRouteChildren: AuthedHrFeedbackRouteChildren = {
  AuthedHrFeedbackFormsFormIdRoute: AuthedHrFeedbackFormsFormIdRoute,
  AuthedHrFeedbackSubmissionsSubmissionIdRoute:
    AuthedHrFeedbackSubmissionsSubmissionIdRoute,
  AuthedHrFeedbackTeachersTeacherIdRoute:
    AuthedHrFeedbackTeachersTeacherIdRoute,
}

const AuthedHrFeedbackRouteWithChildren =
  AuthedHrFeedbackRoute._addFileChildren(AuthedHrFeedbackRouteChildren)

interface AuthedHrInterviewsRouteChildren {
  AuthedHrInterviewsSlotIdRoute: typeof AuthedHrInterviewsSlotIdRoute
}

const AuthedHrInterviewsRouteChildren: AuthedHrInterviewsRouteChildren = {
  AuthedHrInterviewsSlotIdRoute: AuthedHrInterviewsSlotIdRoute,
}

const AuthedHrInterviewsRouteWithChildren =
  AuthedHrInterviewsRoute._addFileChildren(AuthedHrInterviewsRouteChildren)

interface AuthedHrPerformanceRouteChildren {
  AuthedHrPerformanceTeachersTeacherIdRoute: typeof AuthedHrPerformanceTeachersTeacherIdRoute
}

const AuthedHrPerformanceRouteChildren: AuthedHrPerformanceRouteChildren = {
  AuthedHrPerformanceTeachersTeacherIdRoute:
    AuthedHrPerformanceTeachersTeacherIdRoute,
}

const AuthedHrPerformanceRouteWithChildren =
  AuthedHrPerformanceRoute._addFileChildren(AuthedHrPerformanceRouteChildren)

interface AuthedHrProbationRouteChildren {
  AuthedHrProbationTeacherIdRoute: typeof AuthedHrProbationTeacherIdRoute
}

const AuthedHrProbationRouteChildren: AuthedHrProbationRouteChildren = {
  AuthedHrProbationTeacherIdRoute: AuthedHrProbationTeacherIdRoute,
}

const AuthedHrProbationRouteWithChildren =
  AuthedHrProbationRoute._addFileChildren(AuthedHrProbationRouteChildren)

interface AuthedMeChildrenRouteChildren {
  AuthedMeChildrenStudentIdMarksRoute: typeof AuthedMeChildrenStudentIdMarksRoute
}

const AuthedMeChildrenRouteChildren: AuthedMeChildrenRouteChildren = {
  AuthedMeChildrenStudentIdMarksRoute: AuthedMeChildrenStudentIdMarksRoute,
}

const AuthedMeChildrenRouteWithChildren =
  AuthedMeChildrenRoute._addFileChildren(AuthedMeChildrenRouteChildren)

interface AuthedPeopleHouseholdsRouteChildren {
  AuthedPeopleHouseholdsHouseholdIdRoute: typeof AuthedPeopleHouseholdsHouseholdIdRoute
}

const AuthedPeopleHouseholdsRouteChildren: AuthedPeopleHouseholdsRouteChildren =
  {
    AuthedPeopleHouseholdsHouseholdIdRoute:
      AuthedPeopleHouseholdsHouseholdIdRoute,
  }

const AuthedPeopleHouseholdsRouteWithChildren =
  AuthedPeopleHouseholdsRoute._addFileChildren(
    AuthedPeopleHouseholdsRouteChildren,
  )

interface AuthedPeopleManagersRouteChildren {
  AuthedPeopleManagersManagerIdRoute: typeof AuthedPeopleManagersManagerIdRoute
}

const AuthedPeopleManagersRouteChildren: AuthedPeopleManagersRouteChildren = {
  AuthedPeopleManagersManagerIdRoute: AuthedPeopleManagersManagerIdRoute,
}

const AuthedPeopleManagersRouteWithChildren =
  AuthedPeopleManagersRoute._addFileChildren(AuthedPeopleManagersRouteChildren)

interface AuthedPeopleStudentsRouteChildren {
  AuthedPeopleStudentsStudentIdRoute: typeof AuthedPeopleStudentsStudentIdRoute
}

const AuthedPeopleStudentsRouteChildren: AuthedPeopleStudentsRouteChildren = {
  AuthedPeopleStudentsStudentIdRoute: AuthedPeopleStudentsStudentIdRoute,
}

const AuthedPeopleStudentsRouteWithChildren =
  AuthedPeopleStudentsRoute._addFileChildren(AuthedPeopleStudentsRouteChildren)

interface AuthedPeopleTeachersRouteChildren {
  AuthedPeopleTeachersTeacherIdRoute: typeof AuthedPeopleTeachersTeacherIdRoute
}

const AuthedPeopleTeachersRouteChildren: AuthedPeopleTeachersRouteChildren = {
  AuthedPeopleTeachersTeacherIdRoute: AuthedPeopleTeachersTeacherIdRoute,
}

const AuthedPeopleTeachersRouteWithChildren =
  AuthedPeopleTeachersRoute._addFileChildren(AuthedPeopleTeachersRouteChildren)

interface AuthedSystemUsersRouteChildren {
  AuthedSystemUsersUserIdRoute: typeof AuthedSystemUsersUserIdRoute
}

const AuthedSystemUsersRouteChildren: AuthedSystemUsersRouteChildren = {
  AuthedSystemUsersUserIdRoute: AuthedSystemUsersUserIdRoute,
}

const AuthedSystemUsersRouteWithChildren =
  AuthedSystemUsersRoute._addFileChildren(AuthedSystemUsersRouteChildren)

interface AuthedAssessmentsAttemptsAttemptIdRouteChildren {
  AuthedAssessmentsAttemptsAttemptIdResultRoute: typeof AuthedAssessmentsAttemptsAttemptIdResultRoute
}

const AuthedAssessmentsAttemptsAttemptIdRouteChildren: AuthedAssessmentsAttemptsAttemptIdRouteChildren =
  {
    AuthedAssessmentsAttemptsAttemptIdResultRoute:
      AuthedAssessmentsAttemptsAttemptIdResultRoute,
  }

const AuthedAssessmentsAttemptsAttemptIdRouteWithChildren =
  AuthedAssessmentsAttemptsAttemptIdRoute._addFileChildren(
    AuthedAssessmentsAttemptsAttemptIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedAcademicOpsRoute: typeof AuthedAcademicOpsRoute
  AuthedAnnouncementsRoute: typeof AuthedAnnouncementsRouteWithChildren
  AuthedChangePasswordRoute: typeof AuthedChangePasswordRoute
  AuthedControlCenterRoute: typeof AuthedControlCenterRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedFamilyRoute: typeof AuthedFamilyRoute
  AuthedFinanceOpsRoute: typeof AuthedFinanceOpsRoute
  AuthedGamesRoute: typeof AuthedGamesRouteWithChildren
  AuthedOperationsRoute: typeof AuthedOperationsRoute
  AuthedProgressRoute: typeof AuthedProgressRoute
  AuthedTodayRoute: typeof AuthedTodayRoute
  AuthedAcademicsAssessmentsRoute: typeof AuthedAcademicsAssessmentsRouteWithChildren
  AuthedAcademicsAttendanceRoute: typeof AuthedAcademicsAttendanceRoute
  AuthedAcademicsBatchesRoute: typeof AuthedAcademicsBatchesRouteWithChildren
  AuthedAcademicsCoursesRoute: typeof AuthedAcademicsCoursesRouteWithChildren
  AuthedAcademicsExamsRoute: typeof AuthedAcademicsExamsRouteWithChildren
  AuthedAcademicsLeaveRoute: typeof AuthedAcademicsLeaveRoute
  AuthedAcademicsMeetingsRoute: typeof AuthedAcademicsMeetingsRouteWithChildren
  AuthedAcademicsProgressRoute: typeof AuthedAcademicsProgressRoute
  AuthedAcademicsReportLeaderboardRoute: typeof AuthedAcademicsReportLeaderboardRoute
  AuthedAcademicsReportReviewRoute: typeof AuthedAcademicsReportReviewRoute
  AuthedAcademicsResourcesRoute: typeof AuthedAcademicsResourcesRouteWithChildren
  AuthedAcademicsWeeklySheetRoute: typeof AuthedAcademicsWeeklySheetRoute
  AuthedCandidateAptitudeRoute: typeof AuthedCandidateAptitudeRoute
  AuthedCandidateDemosRoute: typeof AuthedCandidateDemosRoute
  AuthedCandidateOnboardRoute: typeof AuthedCandidateOnboardRoute
  AuthedCandidateRulesRoute: typeof AuthedCandidateRulesRoute
  AuthedCandidateStatusRoute: typeof AuthedCandidateStatusRoute
  AuthedFinanceFeesRoute: typeof AuthedFinanceFeesRouteWithChildren
  AuthedFinanceIncentivesRoute: typeof AuthedFinanceIncentivesRoute
  AuthedFinanceReceiptsRoute: typeof AuthedFinanceReceiptsRouteWithChildren
  AuthedFinanceSalariesRoute: typeof AuthedFinanceSalariesRouteWithChildren
  AuthedFinanceWithdrawalsRoute: typeof AuthedFinanceWithdrawalsRouteWithChildren
  AuthedHrApplicationsRoute: typeof AuthedHrApplicationsRouteWithChildren
  AuthedHrFeedbackRoute: typeof AuthedHrFeedbackRouteWithChildren
  AuthedHrInterviewsRoute: typeof AuthedHrInterviewsRouteWithChildren
  AuthedHrPerformanceRoute: typeof AuthedHrPerformanceRouteWithChildren
  AuthedHrProbationRoute: typeof AuthedHrProbationRouteWithChildren
  AuthedMeAssessmentsRoute: typeof AuthedMeAssessmentsRoute
  AuthedMeAttendanceRoute: typeof AuthedMeAttendanceRoute
  AuthedMeChildrenRoute: typeof AuthedMeChildrenRouteWithChildren
  AuthedMeFeedbackRoute: typeof AuthedMeFeedbackRoute
  AuthedMeFeesRoute: typeof AuthedMeFeesRoute
  AuthedMeLeaveRoute: typeof AuthedMeLeaveRoute
  AuthedMeMarksRoute: typeof AuthedMeMarksRoute
  AuthedMePerformanceRoute: typeof AuthedMePerformanceRoute
  AuthedMePointsRoute: typeof AuthedMePointsRoute
  AuthedMeReferralsRoute: typeof AuthedMeReferralsRoute
  AuthedMeReportsRoute: typeof AuthedMeReportsRoute
  AuthedPeopleHouseholdsRoute: typeof AuthedPeopleHouseholdsRouteWithChildren
  AuthedPeopleManagersRoute: typeof AuthedPeopleManagersRouteWithChildren
  AuthedPeopleStudentsRoute: typeof AuthedPeopleStudentsRouteWithChildren
  AuthedPeopleTeachersRoute: typeof AuthedPeopleTeachersRouteWithChildren
  AuthedSystemAuditRoute: typeof AuthedSystemAuditRoute
  AuthedSystemCalendarRoute: typeof AuthedSystemCalendarRoute
  AuthedSystemFeatureFlagsRoute: typeof AuthedSystemFeatureFlagsRoute
  AuthedSystemHiringConfigRoute: typeof AuthedSystemHiringConfigRoute
  AuthedSystemPerformanceConfigRoute: typeof AuthedSystemPerformanceConfigRoute
  AuthedSystemScheduledJobsRoute: typeof AuthedSystemScheduledJobsRoute
  AuthedSystemSettingsRoute: typeof AuthedSystemSettingsRoute
  AuthedSystemTeacherReportsRoute: typeof AuthedSystemTeacherReportsRoute
  AuthedSystemUsersRoute: typeof AuthedSystemUsersRouteWithChildren
  AuthedAssessmentsAttemptsAttemptIdRoute: typeof AuthedAssessmentsAttemptsAttemptIdRouteWithChildren
  AuthedCandidateInterviewBookRoute: typeof AuthedCandidateInterviewBookRoute
  AuthedFinancePayslipsPaymentIdRoute: typeof AuthedFinancePayslipsPaymentIdRoute
  AuthedSystemTeacherReportTemplatesTemplateIdRoute: typeof AuthedSystemTeacherReportTemplatesTemplateIdRoute
  AuthedSystemWalletAdjustmentsRoute: typeof AuthedSystemWalletAdjustmentsRoute
  AuthedAssessmentsRunsRunIdStartRoute: typeof AuthedAssessmentsRunsRunIdStartRoute
  AuthedMeReportKindBatchIdPeriodKeyRoute: typeof AuthedMeReportKindBatchIdPeriodKeyRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAcademicOpsRoute: AuthedAcademicOpsRoute,
  AuthedAnnouncementsRoute: AuthedAnnouncementsRouteWithChildren,
  AuthedChangePasswordRoute: AuthedChangePasswordRoute,
  AuthedControlCenterRoute: AuthedControlCenterRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedFamilyRoute: AuthedFamilyRoute,
  AuthedFinanceOpsRoute: AuthedFinanceOpsRoute,
  AuthedGamesRoute: AuthedGamesRouteWithChildren,
  AuthedOperationsRoute: AuthedOperationsRoute,
  AuthedProgressRoute: AuthedProgressRoute,
  AuthedTodayRoute: AuthedTodayRoute,
  AuthedAcademicsAssessmentsRoute: AuthedAcademicsAssessmentsRouteWithChildren,
  AuthedAcademicsAttendanceRoute: AuthedAcademicsAttendanceRoute,
  AuthedAcademicsBatchesRoute: AuthedAcademicsBatchesRouteWithChildren,
  AuthedAcademicsCoursesRoute: AuthedAcademicsCoursesRouteWithChildren,
  AuthedAcademicsExamsRoute: AuthedAcademicsExamsRouteWithChildren,
  AuthedAcademicsLeaveRoute: AuthedAcademicsLeaveRoute,
  AuthedAcademicsMeetingsRoute: AuthedAcademicsMeetingsRouteWithChildren,
  AuthedAcademicsProgressRoute: AuthedAcademicsProgressRoute,
  AuthedAcademicsReportLeaderboardRoute: AuthedAcademicsReportLeaderboardRoute,
  AuthedAcademicsReportReviewRoute: AuthedAcademicsReportReviewRoute,
  AuthedAcademicsResourcesRoute: AuthedAcademicsResourcesRouteWithChildren,
  AuthedAcademicsWeeklySheetRoute: AuthedAcademicsWeeklySheetRoute,
  AuthedCandidateAptitudeRoute: AuthedCandidateAptitudeRoute,
  AuthedCandidateDemosRoute: AuthedCandidateDemosRoute,
  AuthedCandidateOnboardRoute: AuthedCandidateOnboardRoute,
  AuthedCandidateRulesRoute: AuthedCandidateRulesRoute,
  AuthedCandidateStatusRoute: AuthedCandidateStatusRoute,
  AuthedFinanceFeesRoute: AuthedFinanceFeesRouteWithChildren,
  AuthedFinanceIncentivesRoute: AuthedFinanceIncentivesRoute,
  AuthedFinanceReceiptsRoute: AuthedFinanceReceiptsRouteWithChildren,
  AuthedFinanceSalariesRoute: AuthedFinanceSalariesRouteWithChildren,
  AuthedFinanceWithdrawalsRoute: AuthedFinanceWithdrawalsRouteWithChildren,
  AuthedHrApplicationsRoute: AuthedHrApplicationsRouteWithChildren,
  AuthedHrFeedbackRoute: AuthedHrFeedbackRouteWithChildren,
  AuthedHrInterviewsRoute: AuthedHrInterviewsRouteWithChildren,
  AuthedHrPerformanceRoute: AuthedHrPerformanceRouteWithChildren,
  AuthedHrProbationRoute: AuthedHrProbationRouteWithChildren,
  AuthedMeAssessmentsRoute: AuthedMeAssessmentsRoute,
  AuthedMeAttendanceRoute: AuthedMeAttendanceRoute,
  AuthedMeChildrenRoute: AuthedMeChildrenRouteWithChildren,
  AuthedMeFeedbackRoute: AuthedMeFeedbackRoute,
  AuthedMeFeesRoute: AuthedMeFeesRoute,
  AuthedMeLeaveRoute: AuthedMeLeaveRoute,
  AuthedMeMarksRoute: AuthedMeMarksRoute,
  AuthedMePerformanceRoute: AuthedMePerformanceRoute,
  AuthedMePointsRoute: AuthedMePointsRoute,
  AuthedMeReferralsRoute: AuthedMeReferralsRoute,
  AuthedMeReportsRoute: AuthedMeReportsRoute,
  AuthedPeopleHouseholdsRoute: AuthedPeopleHouseholdsRouteWithChildren,
  AuthedPeopleManagersRoute: AuthedPeopleManagersRouteWithChildren,
  AuthedPeopleStudentsRoute: AuthedPeopleStudentsRouteWithChildren,
  AuthedPeopleTeachersRoute: AuthedPeopleTeachersRouteWithChildren,
  AuthedSystemAuditRoute: AuthedSystemAuditRoute,
  AuthedSystemCalendarRoute: AuthedSystemCalendarRoute,
  AuthedSystemFeatureFlagsRoute: AuthedSystemFeatureFlagsRoute,
  AuthedSystemHiringConfigRoute: AuthedSystemHiringConfigRoute,
  AuthedSystemPerformanceConfigRoute: AuthedSystemPerformanceConfigRoute,
  AuthedSystemScheduledJobsRoute: AuthedSystemScheduledJobsRoute,
  AuthedSystemSettingsRoute: AuthedSystemSettingsRoute,
  AuthedSystemTeacherReportsRoute: AuthedSystemTeacherReportsRoute,
  AuthedSystemUsersRoute: AuthedSystemUsersRouteWithChildren,
  AuthedAssessmentsAttemptsAttemptIdRoute:
    AuthedAssessmentsAttemptsAttemptIdRouteWithChildren,
  AuthedCandidateInterviewBookRoute: AuthedCandidateInterviewBookRoute,
  AuthedFinancePayslipsPaymentIdRoute: AuthedFinancePayslipsPaymentIdRoute,
  AuthedSystemTeacherReportTemplatesTemplateIdRoute:
    AuthedSystemTeacherReportTemplatesTemplateIdRoute,
  AuthedSystemWalletAdjustmentsRoute: AuthedSystemWalletAdjustmentsRoute,
  AuthedAssessmentsRunsRunIdStartRoute: AuthedAssessmentsRunsRunIdStartRoute,
  AuthedMeReportKindBatchIdPeriodKeyRoute:
    AuthedMeReportKindBatchIdPeriodKeyRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  ActivateRoute: ActivateRoute,
  ForgotRoute: ForgotRoute,
  LoginRoute: LoginRoute,
  OtpRoute: OtpRoute,
  ResetRoute: ResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
